{
    "Api tokens": {
        "add token": "Token hinzufügen",
        "description": "Generiert einen API-Token für den OEM-Datei Download für TCT und den Configurator oder einen API-Token für die Anwendung, der bei der Anforderung von FOTA WEB-Diensten verwendet wird. Die API-Dokumentation finden Sie <1>hier</1>.",
        "example": "Beispiel: fota_token",
        "generate token": "Token generieren",
        "generated token": "Generiertes Token",
        "last used at": "Zuletzt verwendet bei",
        "name": "Token-Name",
        "never": "Niemals",
        "no tokens": "Keine Token verfügbar",
        "no tokens description": "Sobald Token hinzugefügt wurden, werden sie hier unten aufgelistet",
        "show token list": "Token-Liste anzeigen",
        "titles": {
            "Integration": {
                "description": "Wird für die FOTA WEB-Integration in Ihr System verwendet",
                "name": "API-Token für die Integration"
            },
            "Tct": {
                "description": "Wird für den OEM-Datei Download für TCT und Configurator verwendet",
                "name": "TCT-Token"
            }
        },
        "tokens": "API-Token",
        "token type": "Token-Typ",
        "token was created": "Token wurde erfolgreich erstellt"
    },
    "Attributes": {
        "Completed": "Abgeschlossen",
        "Count": "Zählen",
        "Current": "Aktuell",
        "Date": "Datum",
        "Empty": "Leer",
        "excluded files": "Ausgeschlossene Dateien (samegrade)",
        "Failed": "Fehlgeschlagen",
        "Feature": "Funktion",
        "file size bytes": "Gesamt Datei Größe",
        "File_type": "Datei Typ",
        "File_version": "Datei Version",
        "Fingerprint_id": "Fingerabdruck-ID",
        "Firmware_date": "Firmware-Datum",
        "Firmware_version": "Firmware Version",
        "included files": "Enthaltene Dateien",
        "Message": "Nachricht",
        "Metadata": "",
        "newest": "Neuesten",
        "oldest": "Ältesten",
        "Order": "Bestellung",
        "Password_source": "",
        "Pending": "Noch nicht abgeschlossen",
        "Period": "Zeitraum",
        "Process_id": "",
        "Protocol_id": "Protokoll-ID",
        "specific": "Spezifisch",
        "Start": "Start",
        "SystemGenerated": "",
        "txFwBundleFileTypes": {
            "fw_bundle_ble": "BLE Firmware",
            "fw_bundle_ble_dtb": "BLE DTB",
            "fw_bundle_can": "CAN Firmware",
            "fw_bundle_can_dtb": "CAN DTB",
            "fw_bundle_dtb": "TAPP DTB",
            "fw_bundle_mainfw": "TAPP Firmware"
        },
        "UserEntered": "",
        "vehicle": "Fahrzeug",
        "Vehicle_id": "Fahrzeug-ID",
        "Vin": "VIN"
    },
    "Auth": {
        "account verification": {
            "check autheticator": "Überprüfen Sie Ihre Authentifizierungs-App",
            "check email": "Überprüfen Sie Ihre E-Mails",
            "code required": "Verifizierungscode erforderlich.",
            "code sent to email": "Code wird an Ihre E-Mail-Adresse gesendet",
            "code valid": "Der Code ist gültig.",
            "enter code below": "Geben Sie den Code ein, um sich anzumelden.",
            "no access to otp": "",
            "recovery code": {
                "banner text": "",
                "description": "",
                "secondary text": "",
                "title": ""
            },
            "title": "",
            "use recovery code": ""
        },
        "account verification description": "Kontoüberprüfung erforderlich. Überprüfen Sie Ihre Authentifizierungs-App und geben Sie den Code unten ein, um sich anzumelden.",
        "check email": "Bitte überprüfen Sie Ihren Posteingang und klicken Sie auf den erhaltenen Link, um Ihr Passwort zurückzusetzen.",
        "community forum": "Crowd-Support-Forum",
        "contact us": "Kontaktieren Sie uns",
        "create initial password": "Passwort erstellen",
        "create password": "Erstellen Sie ein Passwort",
        "did not receive": "Haben Sie den Link nicht erhalten?",
        "do not have account": "Haben Sie noch kein Konto?",
        "email": "E-Mail",
        "enter email": "Bitte geben Sie unten Ihre registrierte E-Mail-Adresse ein, um Anweisungen zum Zurücksetzen Ihres Passworts zu erhalten.",
        "forgot password": "Passwort vergessen?",
        "forgot your password": "Ihr Passwort vergessen?",
        "for ms365": "Für Teltonika MS365-Benutzer",
        "invalid email format": "Ungültiges E-Mail-Format",
        "invalid password format": "Ungültiges Passwortformat",
        "link sent": "Der Link wurde gesendet!",
        "length": "Mindestens 8 Zeichen",
        "lowercase": "Enthält mindestens 1 Kleinbuchstabe",
        "new password": "Neues Passwort",
        "password": "Passwort",
        "passwords do not match": "Passwörter stimmen nicht überein",
        "privacy policy": "Durch die Nutzung von FOTA WEB erklären Sie sich mit unserer <1>Datenschutzerklärung</1> einverstanden.",
        "remember password": "Erinnern Sie sich an Ihr Passwort?",
        "repeat password": "Passwort wiederholen",
        "required": "Erforderlich",
        "resend": "Erneut senden",
        "reset password": "Passwort zurücksetzen",
        "send reset link": "Link zum Zurücksetzen senden",
        "sign in": "Anmelden",
        "sign in to fota": "Melden Sie sich bei Ihrem FOTA WEB-Konto an",
        "signup": "Anmelden",
        "sso": "Mit Microsoft anmelden",
        "teltonika telematics": "Teltonika Telematics",
        "uppercase": "Großbuchstabe",
        "user consent text": "Ich verstehe und akzeptiere die <1>Nutzungsbedingungen</1> von Teltonika und die <2>Datenverarbeitungsvereinbarung</2>.",
        "welcome": "Willkommen bei",
        "wiki": "Telematik-Wiki-Wissensdatenbank"
    },
    "Banner": {
        "activate banner": "",
        "apply link": "",
        "banner importance": "",
        "bold": "",
        "close link": "",
        "info": "",
        "italic": "",
        "link": "",
        "message": "",
        "text": "",
        "underline": "",
        "url": "",
        "warning": ""
    },
    "Button": {
        "accept": "Akzeptieren",
        "accept all": "Alle akzeptieren",
        "accept selected": "Ausgewählte akzeptieren",
        "actions": "Aktionen",
        "add": "Hinzufügen",
        "add device": "Gerät hinzufügen",
        "add more files": "Weitere Dateien hinzufügen",
        "add new": "Neu hinzufügen",
        "agree": "Ich stimme zu",
        "all companies": "Alle Unternehmen",
        "all of company": "Alle {{companyName}}",
        "all rows selected": {
            "devices": "Alle {{count}} Geräte sind ausgewählt",
            "tasks": "Alle {{count}} anstehenden/laufenden Aufgaben sind ausgewählt",
            "groups": "Alle {{count}} Gruppen sind ausgewählt",
            "files": "Alle {{count}} Dateien sind ausgewählt",
            "companies": "Alle {{count}} Unternehmen sind ausgewählt",
            "users": "Alle {{count}} Benutzer sind ausgewählt"
        },
        "approve": "Genehmigen",
        "assign": "Zuweisen",
        "assigning": "Zuweisung",
        "auto sync": "",
        "back": "Zurück",
        "back to sign in": "Zurück zur Anmeldung",
        "cancel": "Abbrechen",
        "cancelling": "Stornieren",
        "cancel all tasks in group": "Alle Aufgaben in der Gruppe abbrechen",
        "cancel tasks": "Aufgaben abbrechen",
        "cannot create desktop licenses": "Für interne Unternehmen können keine Lizenzen erstellt werden.",
        "cannot create offline licenses": "Für uneingeschränkte Lizenzen können keine Offline-Lizenzen erstellt werden.",
        "change": "Ändern",
        "clear all": "Alle löschen",
        "clear all filters": "Alle Filter löschen",
        "close": "Schließen",
        "company settings": "Unternehmenseinstellungen",
        "confirm": "Bestätigen",
        "continue": "Weiter",
        "copied": "Kopiert",
        "copy all": "",
        "copy to clipboard": "In die Zwischenablage kopieren",
        "create": "Erstellen",
        "create role": "Rolle erstellen",
        "create task": "Aufgabe erstellen",
        "creating": "Erstellen",
        "default view": "Standardansicht",
        "delete": "Löschen",
        "deleting": "Löschen",
        "deselect all": "Alle abwählen",
        "device": "Gerät",
        "disable": "Deaktivieren",
        "disagree": "Ich bin nicht einverstanden",
        "discard": "Verwerfen",
        "download": "",
        "edit": "Bearbeiten",
        "enable": "Aktivieren",
        "export": "Exportieren",
        "exporting": "Exportieren",
        "filters": "Filter",
        "finish": "",
        "find tool": "Tool finden",
        "first page": "Erste Seite",
        "fmx and legacy": "FMx und Legacy",
        "ft platform": "FT-Plattform",
        "generate": "Generieren",
        "generate codes": "",
        "go back": "Zurück",
        "import": "Importieren",
        "importing": "Importieren",
        "invite": "Einladen",
        "invite user": "Benutzer einladen",
        "invite user to internal disabled": "Nur Admin-Manager und höhere Zugriffsebenen können Benutzer zu internen Unternehmen einladen.",
        "language": "Sprache",
        "last page": "Letzte Seite",
        "logout": "Abmelden",
        "maximize details": "Details maximieren",
        "merge": "Zusammenführen",
        "merging": "Zusammenführen",
        "minimize details": "Details minimieren",
        "more actions": "Weitere Aktionen",
        "more filters": "Weitere Filter",
        "more options": "Weitere Optionen",
        "move": "Verschieben",
        "moving": "verschiebung",
        "next": "Weiter",
        "next month": "Nächster Monat",
        "next page": "Nächste Seite",
        "no actions available": "Keine Aktionen verfügbar",
        "no permission": "Sie benötigen die Berechtigung „{{permissionName}}“.",
        "no permissions": "Sie benötigen die folgenden Berechtigungen: {{permissionNames}}.",
        "notify when done": "Benachrichtigen Sie mich, wenn fertig",
        "number of selected companies": "{{companyCount}} von {{companyName}}",
        "only essential": "Nur das Wesentliche",
        "open fota web": "Open FOTA WEB",
        "pages of": "von {{total}}",
        "previous month": "Vormonat",
        "previous page": "Vorherige Seite",
        "print": "",
        "receive devices": "Geräte empfangen",
        "refresh page": "Aktualisieren",
        "reject all": "Alle ablehnen",
        "reset to default": "Auf Standard zurücksetzen",
        "retry failed tasks": "Wiederholen fehlgeschlagene Aufgaben",
        "retrying": "Wiederholen",
        "return home": "Zurück zur Haupt-Ansicht",
        "revert manual level change": "Manuelle Level-Änderung rückgängig machen",
        "rows count per page": "Anzahl der Zeilen pro Seite",
        "rows selected": "{{count}} Ausgewählt",
        "save": "Speichern",
        "saving": "",
        "see all": "Alle anzeigen",
        "select all": {
            "devices": "Alle {{count}} Geräte auswählen",
            "tasks": "Alle {{count}} anstehenden/laufenden Aufgaben auswählen",
            "groups": "Alle {{count}} Gruppen auswählen",
            "files": "Alle {{count}} Dateien auswählen",
            "companies": "Alle {{count}} Unternehmen auswählen",
            "users": "Alle {{count}} Benutzer auswählen"
        },
        "select columns to show": "Zu zeigende Spalten auswählen",
        "selected page is first": "Die ausgewählte Seite ist die erste",
        "selected page is last": "Die ausgewählte Seite ist die letzte",
        "select rows": "Zeilen auswählen",
        "send code": "Code senden",
        "settings": "Einstellungen",
        "show me": "Zeigen Sie mir",
        "show more": "Mehr anzeigen",
        "synchronize": "Synchronisieren",
        "table statistics": "Tabellenstatistik",
        "table view": "Tabellenansicht",
        "transfer": "Übertragung",
        "transferring": "Übertragung",
        "transfer my devices": "Meine Geräte übertragen",
        "undo": "Rückgängig machen",
        "upload": "Hochladen",
        "upload file": "Neue Datei hochladen",
        "user": "Benutzer",
        "verify": "Überprüfen",
        "yes": "Ja"
    },
    "Cookies": {
        "always active": "Immer aktiv",
        "analytics cookies": "Analytics-Cookies",
        "analytics cookies description": "Diese Analztics Cookies werden für Analysen verwendet, um Daten zu sammeln, die uns helfen zu verstehen, wie Nutzer mit unseren Websites interagieren. Diese Erkenntnisse ermöglichen es uns, sowohl Inhalte zu verbessern als auch bessere Funktionen zu entwickeln, um das Nutzererlebnis zu verbessern. Diese Kategorie von Cookies kann deaktiviert werden.",
        "cookie banner message": "Wir und ausgewählte Dritte verwenden Cookies oder ähnliche Technologien für technische Zwecke und, mit Ihrer Zustimmung, für andere Zwecke, wie in der ",
        "cookie modal title": "Wir verwenden Cookies",
        "cookie policy": "Cookie-Richtlinie",
        "essential cookies": "Unbedingt erforderliche Cookies",
        "essential cookies description": "Diese Cookies werden für Aktivitäten verwendet, die für den Betrieb oder die Bereitstellung der von Ihnen angeforderten Dienstleistung unbedingt erforderlich sind. Diese Cookies sammeln keine Informationen über Sie, die für Marketingzwecke verwendet werden könnten, und speichern nicht, welche Websites Sie im Internet besucht haben. Diese Kategorie von Cookies kann nicht deaktiviert werden."
    },
    "Dashboard": {
        "company level": {
            "description": {
                "Basic": "Unverzichtbar für die Fernaktualisierung von Geräten",
                "Standard": "Fortschrittliche Automatisierung und Integration",
                "Premium": "Skalierbarkeit für Unternehmen und frühzeitiger Zugriff auf Updates"
            },
            "resource limit types": {
                "Companies": "Unternehmen",
                "Users": "Benutzer",
                "ConfigurationFiles": "Konfigurationsdateien"
            }
        },
        "empty state": {
            "description": {
                "configurations": "Sobald Konfigurationen von FOTA WEB identifiziert werden, können Sie die Liste hier einsehen.",
                "firmware versions": "Sobald Firmware-Versionen von FOTA WEB identifiziert werden, können Sie die Liste hier einsehen."
            },
            "title": {
                "configurations": "Keine Konfigurationen identifiziert",
                "firmware versions": "Keine Firmware-Versionen identifiziert",
                "news": "Keine Neuigkeiten"
            }
        },
        "imported activated devices": {
            "days": {
                "1": "Heute",
                "7": "7 Tage",
                "30": "30 Tage",
                "90": "90 Tage"
            },
            "period": "Zeitraum"
        },
        "new": "",
        "news": {
            "body": {
                "1": "Wir möchten Sie daran erinnern, dass für Benutzer, die nach dem 7. Januar 2025 eingeladen werden, die 2FA sofort nach der Kontoaktivierung obligatorisch ist. Die Zwei-Faktor-Authentifizierung ist per E-Mail-Verifizierung oder über eine Authentifizierungs-App verfügbar.",
                "2": "Wir möchten Sie über geplante Wartungsarbeiten an FOTA WEB informieren, die am 3. Juni 2025 ab 05:00 UTC stattfinden werden. Bitte beachten Sie, dass während der Wartungsarbeiten alle Dienste nicht verfügbar sein werden, einschließlich Benutzeroberfläche, API-Zugriff, Aufgabenausführung, OBD- und CAN-Dienste. Die voraussichtliche Dauer der Nichtverfügbarkeit der Dienste beträgt 1 Stunde.",
                "3": "<section><p>Wir freuen uns, eine wichtige Verbesserung der Device Unlocker-Funktion auf FOTA WEB bekannt zu geben:</p></section> <section><p>Alle Benutzerrollen können nun Geräte direkt entsperren – es ist nicht mehr erforderlich, den technischen Support über den Helpdesk zu kontaktieren!</p> <p>Wichtige Details:</p> <ul><li>Benutzer können dasselbe Gerät innerhalb von 24 Stunden bis zu dreimal entsperren.</li> <li>Nach Erreichen des Limits wird die Entsperrungsoption für 24 Stunden vorübergehend deaktiviert. </li> <li>Wenn das Entsperrungslimit überschritten wird, erscheint eine Fehlermeldung. Dieses Update reduziert die Wartezeiten erheblich und gibt Ihnen mehr Kontrolle über Ihr Flottenmanagement. </li></ul></section> <section><a>Erfahren Sie, wie Sie die Funktion nutzen können</a></section>",
                "4": "<section><p>Wir freuen uns, Ihnen einige großartige neue Updates für das FOTA WEB-Dashboard vorstellen zu können! Wir haben daran gearbeitet, Ihre Erfahrung mit verbesserten Widgets und neuen Einblicken zu verbessern. </p></section> <section><h3>Neue Gerätestatistiken</h3> <p>Verschaffen Sie sich mit zwei brandneuen Widgets einen besseren Einblick in Ihre Geräteaktivitäten:</p> <p><strong>Aktivierte Geräte</strong>: Diese neue Statistik zeigt Ihnen, wie viele Geräte in verschiedenen Zeiträumen aktiviert (verbunden) wurden: heute, 7 Tage, 30 Tage oder 90 Tage. </p> <p><strong>Importierte Geräte</strong>: In ähnlicher Weise verfolgt die neue Statistik „Importierte Geräte”, wie viele Geräte heute, in den letzten 7 Tagen, 30 Tagen oder 90 Tagen importiert wurden.</p> </section> <section><h3>Vorstellung des Aufgaben-Widgets</h3> <p>Behalten Sie den Überblick über Ihre Vorgänge mit dem brandneuen Aufgaben-Widget:</p> <p><strong>Aufgaben in der Warteschlange</strong>: Sehen Sie eine übersichtliche Anzahl Ihrer derzeit ausstehenden Aufgaben.</p> <p><strong>Aufgabenübersicht</strong>: Erhalten Sie eine Aufschlüsselung Ihrer Aufgabenverteilung nach Zeitraum (7 Tage, 30 Tage oder 90 Tage) und Status. Dazu gehören Aufgaben, die abgeschlossen, mit Fehlern abgeschlossen oder fehlgeschlagen sind.</p></section> <section><h3>Intelligentere Firmware- und Konfigurationsübersichten</h3> <p>Wir haben die Widgets für Firmware-Versionen und Konfigurationen überarbeitet:</p> <ul><li>Wir haben die Statistik „Unbekannt” entfernt, um die Daten übersichtlicher zu gestalten.</li> <li>Die UI zeigt nun die Namen der Firmware-Versionen und Konfigurationen sowie ihre counts klarer an.</li> <li>Zunächst werden die fünf wichtigsten Versionen oder Konfigurationen angezeigt, mit der Option „Mehr anzeigen”, um bis zu 100 verschiedene Einträge anzuzeigen. </li> <li>Wenn Sie mit der Maus über eine bestimmte Firmware oder Konfiguration fahren und darauf klicken, gelangen Sie zur „Geräteseite” und können einen Filter anwenden.</li></ul></section> <section><h3>Verbessertes Nachrichten-Widget</h3> <p>Bleiben Sie auf einen Blick informiert! Das Nachrichten-Widget hat ein neues Aussehen erhalten, und Sie können nun auch auf jede Nachricht klicken, um die vollständigen Informationen zu lesen. </p></section> <section><h3>Verbesserter Gerätestatus</h3> <p>Das Widget „Gerätestatus“ wurde zur besseren Übersichtlichkeit optisch überarbeitet. Außerdem können Sie nun mit der Maus über den Status eines Geräts fahren und darauf klicken, um Geräte mit dem entsprechenden Status auf der Seite „Geräte“ herauszufiltern. </p></section> <section><p>Wir hoffen, dass diese Aktualisierungen Ihre täglichen Aufgaben noch einfacher machen und Ihnen wertvollere Informationen liefern. Teilen Sie uns Ihre Meinung mit!</p></section>",
                "5": "<section><h3>Geplante API-Änderungen</h3></section> <section><p>Am <strong>24. September 2025</strong> werden wir das Feld „role” aus den Antworten entfernen, die die Benutzerentität zurückgeben (z. B. GET /users oder GET /users/{userId} Endpunkte). Diese Änderung wird vorgenommen, um den Weg für ein robusteres und flexibleres Berechtigungssystem in FOTA WEB zu ebnen.</p></section> <section><h3>Vorschau: Rollen und Berechtigungen</h3></section> <section><p> Wir sind uns bewusst, dass das derzeitige Rollensystem nicht die Flexibilität bietet, die Sie benötigen. Unser Entwicklungsteam arbeitet intensiv an einer neuen Funktion zur <strong>Verwaltung von Rollen und Berechtigungen</strong>, mit der Sie Rollen mit detaillierter Kontrolle über Berechtigungen erstellen können.</p></section> <section><p>Mit diesem neuen System können Sie Benutzern statische Rollen zuweisen, Berechtigungen an Ihre spezifischen Anforderungen anpassen und benutzerdefinierte Rollen erstellen. Wir freuen uns sehr darüber und werden Ihnen weitere Details zur Rollen- und Berechtigungsverwaltung mitteilen, sobald diese verfügbar sind. </p></section>",
                "6": "<section><p>Wir freuen uns, die Veröffentlichung der neuen Funktion <strong>„Rollen und Berechtigungen”</strong> bekannt zu geben, mit der Sie den Benutzerzugriff innerhalb von FOTA WEB präzise steuern können. Mit dieser Funktion können Sie Benutzerrechte mithilfe von <strong>Rollen</strong> definieren, bei denen es sich um bestimmte <strong>Berechtigungen</strong> handelt (z. B. „Aufgabe erstellen”, „Benutzer einladen”). Die Funktion umfasst unveränderliche <strong>statische Rollen</strong> – Administrator, Benutzer und Gast – für die grundlegende Sicherheit sowie anpassbare <strong>benutzerdefinierte Rollen</strong>, die nur Benutzer mit <strong>Premium-Unternehmensstatus</strong> erstellen oder bearbeiten können. Berechtigungen sind nun nach Schlüsselbereichen wie Geräte, Aufgaben und Benutzer kategorisiert und können durch Bewegen des Mauszeigers über die „Anzahl der Berechtigungen“ im Verwaltungsbereich angezeigt werden. <strong>Allen bestehenden Benutzern, die vor diesem Update erstellt wurden, wurde automatisch die Rolle „Administrator“ zugewiesen, sodass sie weiterhin alle Aktionen ausführen können, die sie zuvor ausgeführt haben. </strong></p></section> <section><p>Dieses Update sorgt für mehr Sicherheit und eine bessere Verteilung der Arbeitslast. Rollen sind nun unternehmensspezifisch und können nicht über Unternehmensstrukturen hinweg vererbt werden. Beachten Sie, dass beim Einladen oder Verschieben eines Benutzers in ein Unternehmen immer eine Rolle zugewiesen werden muss und dass Rollen mit aktiven Benutzerzuweisungen nicht gelöscht werden können. Sie können nun den <strong>neuen Filter „Rolle”</strong> auf der Seite <strong>Benutzer</strong> verwenden, um die Verwaltung zu vereinfachen. Sehen Sie sich noch heute den Abschnitt „Rollen und Berechtigungen” an, um den Zugriff entsprechend den Anforderungen Ihres Unternehmens zu konfigurieren.</p></section> <section><p>Eine ausführliche Anleitung zur Verwaltung von Benutzern und Rollen finden Sie auf <a>der Wiki-Seite</a>.</p></section>",
                "7": "<section><p>Wir freuen uns, Ihnen mit der Funktion „Nach Datum planen” eine leistungsstarke neue Möglichkeit zur Verwaltung Ihrer Aufgaben vorstellen zu können, mit der Sie zeitkritische Arbeiten noch präziser erledigen können!</p></section> <section><h3>Wichtigste Highlights</h3></section> <section><ul><li><strong>Spezifische Fristen</strong> – Mit der neuen Option „Nach Datum planen” können Sie Aufgaben nun für ein <strong>bestimmtes Datum oder einen bestimmten Zeitraum</strong> planen.</li> <li><strong>Standardverhalten unverändert</strong> – Die bekannte Funktion „Nach Zeit planen“ steht weiterhin uneingeschränkt zur Verfügung. </li> <li><strong>Ablaufstatus</strong> – Aufgaben, die bis zum festgelegten Datum nicht abgeschlossen sind, ändern nun automatisch ihren Status in „Abgelaufen“ und werden mit der Meldung „Die Aufgabe wurde nicht innerhalb des festgelegten Zeitplans abgeschlossen“ versehen.</strong></li> <li><strong>Benutzerorientiertes Timing</strong> – Alle Zeitpläne werden auf der Grundlage <strong>Ihrer Ortszeit</strong> erstellt. </li></ul></section> <section><h3>So funktioniert es</h3></section> <section><p>Beim Festlegen der Aufgabe <strong>„Nach Datum planen“</strong>:</p> <ul><li>Sie wählen über die Datumsauswahlkomponente ein <strong>„Startdatum“</strong> und ein <strong>„Enddatum“</strong> aus. </li> <li>Die Datumsauswahl berücksichtigt die Ablaufzeit für Aufgaben auf Unternehmensebene.</li></ul></section><section><p>Die Funktion <strong>Nach Datum planen</strong> ist derzeit nur für höhere Unternehmensebenen verfügbar und steht für die Stufe <strong>Basic</strong> nicht zur Verfügung.</p></section>",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            },
            "title": {
                "1": "Obligatorische 2FA für neue Benutzer ab dem 7. Januar 2025",
                "2": "Geplante Wartungsarbeiten am 3. Juni 2025",
                "3": "Neues Feature-Update: Einfacheres Entsperren von Geräten für alle Benutzer",
                "4": "Entdecken Sie die Neuheiten auf Ihrem Dashboard!",
                "5": "Wichtig: Bevorstehende API-Änderungen und Einblick in Rollen und Berechtigungen",
                "6": "Neue Funktion jetzt verfügbar: Verbesserte Kontrolle mit „Rollen und Berechtigungen”",
                "7": "Neue Funktion: Mehr Flexibilität mit Aufgabenplanung nach Datum",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            }
        },
        "published": "Veröffentlicht am",
        "take me there": "Weiter",
        "tasks": {
            "current": "Aktuell",
            "status": {
                "completed": "Abgeschlossen",
                "completed_with_errors": "Mit Fehlern abgeschlossen",
                "failed": "Fehlgeschlagen",
                "no tasks": "Keine Aufgaben"
            },
            "task_type_counts_7_days": {
                "progressBarTitle": "7 Tage",
                "tooltipTitle": "Letzte 7 Tage"
            },
            "task_type_counts_30_days": {
                "progressBarTitle": "30 Tage",
                "tooltipTitle": "Letzte 30 Tage"
            },
            "task_type_counts_90_days": {
                "progressBarTitle": "90 Tage",
                "tooltipTitle": "Letzte 90 Tage"
            }
        },
        "title": {
            "activated": "Aktivierte Geräte",
            "configurations": "Konfigurationen",
            "device status": "Gerätestatus",
            "firmware versions": "Firmware-Versionen",
            "imported": "Importierte Geräte",
            "news": "Neuigkeiten",
            "queued tasks": "Aufgaben in der Warteschlange",
            "refreshed every hour": "Stündlich aktualisiert",
            "resource limits": "Ressourcenbeschränkungen",
            "task overview": "Aufgabenübersicht",
            "tasks": "Aufgaben"
        },
        "tooltips": {
            "activated": "Anzahl der Geräte, die während des ausgewählten Zeitraums (heute, letzte 7 Tage, letzte 30 Tage, letzte 90 Tage) zum ersten Mal mit FOTA WEB verbunden wurden.",
            "configurations": "Zeigt die Verteilung der Konfigurationsdateinamen an, die auf Ihre Geräte hochgeladen wurden. Es werden bis zu 100 eindeutige Dateinamen angezeigt.",
            "firmware versions": "Zeigt die Verteilung der von Ihren verbundenen Geräten gemeldeten Firmware-Versionen an. Es werden bis zu 100 eindeutige Versionen angezeigt.",
            "imported": "Die Anzahl der Geräte, die während des ausgewählten Zeitraums (heute, letzte 7 Tage, letzte 30 Tage, letzte 90 Tage) zu Ihrem Konto hinzugefügt wurden."
        }
    },
    "Date picker": {
        "disableFuture": "Ungültiges Datum",
        "disablePast": "Ungültiges Datum",
        "invalidDate": "Ungültiges Datum",
        "maxDate": "Falsches Datum",
        "minDate": "Falsches Datum",
        "shouldDisableDate": "Ungültiges Datum",
        "shouldDisableMonth": "Ungültiges Datum",
        "shouldDisableYear": "Ungültiges Datum"
    },
    "Device export": {
        "properties": {
            "activity_status": "",
            "bootloader": "",
            "company_name": "",
            "created_at": "",
            "current_configuration": "",
            "current_firmware": "",
            "description": "",
            "group_name": "",
            "gsm_number": "",
            "iccid": "",
            "imei": "",
            "imsi": "",
            "model": "",
            "model_platform": "",
            "modem_version": "",
            "oem_file_vehicle_name": "",
            "product_code": "",
            "seen_at": "",
            "serial": "",
            "task_queue": "",
            "updated_at": "",
            "vin": ""
        },
        "select data": ""
    },
    "Dialog": {
        "access group inheritance": "",
        "add new device": "Neues Gerät hinzufügen",
        "add new device description": "Fügen Sie einzelne oder mehrere neue Geräte zum ausgewählten Unternehmen und zur ausgewählten Gruppe hinzu. Nur ältere Geräte wie FM oder FMA müssen importiert werden, indem Sie das Kontrollkästchen „Als ältere Geräte importieren” aktivieren.",
        "add new device legacy title": "Als Legacy-Geräte importieren.",
        "add new device legacy description": "Setzen Sie „Erstellt am” auf 2016.01.01 und „Modell” auf Legacy.",
        "add new product code": "Neuen Produktcode hinzufügen",
        "add new product code description": "Fügen Sie einen neuen Produktcode für Geräte hinzu und verknüpfen Sie ihn mit dem verfügbaren CAN-Paket.",
        "all permissions": "Alle Berechtigungen",
        "assign access group": "",
        "assign can package description": "Wählen Sie einen Pakettyp aus und weisen Sie ihn allen ausgewählten Geräten zu.",
        "assign role": "Rolle zuweisen",
        "attribute value": "Attributwert",
        "auto sync": "",
        "auto sync toggle": {
            "compatibility": {
                "compatible devices": "",
                "selected devices": ""
            },
            "descriptions": {
                "dialog": "",
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "modes": {
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "tooltips": {
                "bluetooth_auth_list_sync": "",
                "disabled submit": "",
                "main_configuration_sync": "",
                "manual_geofence_list_sync": "",
                "one_wire_auth_list_sync": ""
            }
        },
        "begin download": "Download starten",
        "by date": "Nach Datum",
        "by time": "Nach Zeit",
        "can adapter": "CAN-Adapter",
        "cancel pending tasks": "Ausstehende Aufgaben desselben Aufgabentyps abbrechen",
        "cancel tasks": "Aufgaben abbrechen",
        "cancel tasks in group": {
            "alert title": "Dieser Vorgang kann bis zu mehreren Minuten dauern.",
            "banner description": "Um den aktualisierten Status von Aufgaben anzuzeigen, sehen Sie sich bitte die Details der Aufgabengruppe an oder aktualisieren Sie die Seite.",
            "banner title": "Dieser Vorgang kann je nach Anzahl der Aufgaben bis zu mehreren Minuten dauern.",
            "description": "Durch Klicken auf „Akzeptieren“ werden alle ausstehenden und laufenden Aufgaben abgebrochen. Möchten Sie wirklich fortfahren?",
            "title": "Alle Aufgaben in der Gruppe abbrechen?"
        },
        "canObd": "CAN/OBD",
        "carrier": "Carrier",
        "clear device history banner": "",
        "client email": "E-Mail des Kundenvertreters",
        "companies": "Unternehmen",
        "company": "Unternehmen",
        "company level": {
            "Basic": "Grundlegend",
            "Internal": "Intern",
            "Premium": "Premium",
            "Standard": "Standard"
        },
        "company level change description": "Upgrade einer Unternehmensebene durch Auswahl der neuen Ebene und Angabe einer Begründung. Ein Downgrade einer Unternehmensebene ist nicht möglich. Alle Daten sind in UTC angegeben.",
        "company level manual revert": {
            "confirmation": {
                "description": "Durch diese Aktion wird die Unternehmensebene auf die automatisch zugewiesene Ebene „{{companyLevel}}“ zurückgesetzt. Möchten Sie wirklich fortfahren?",
                "title": "Manuelle Level-Änderung rückgängig machen?"
            },
            "description": "Durch Zurücksetzen wird die Unternehmensebene wieder auf die automatisch zugewiesene Ebene zurückgesetzt.",
            "title": "Diese Unternehmensebene wurde bis zum {{expirationDate}} manuell aktualisiert."
        },
        "company level type": "Typ auf Unternehmensebene",
        "company name": "Firmenname",
        "company statistics": {
            "child companies": "Anzahl der Tochtergesellschaften",
            "devices": "Anzahl der Geräte",
            "files": "Anzahl der Dateien",
            "groups": "Anzahl der Gerätegruppen",
            "tasks": "Anzahl der Aufgaben",
            "users": "Anzahl der Benutzer"
        },
        "company type": {
            "All": "",
            "Client": "Kunde",
            "Internal": "Intern",
            "Virtual": "Virtuell"
        },
        "configuration": "Konfiguration",
        "confirmations": {
            "are you sure": "Sind Sie sicher?",
            "are you sure you wish to continue": "Möchten Sie wirklich fortfahren?",
            "assign can package confirmation": "Möchten Sie das ausgewählte Paket wirklich der angegebenen Anzahl von Geräten zuweisen?",
            "cancel task confirmation": {
                "first part": "Möchten Sie wirklich die angegebene Anzahl von Aufgaben löschen?",
                "second part": "Wenn ja, geben Sie die Anzahl der betroffenen Aufgaben ein und klicken Sie auf „Bestätigen“."
            },
            "create task confirmation": "Möchten Sie wirklich eine Aufgabe für die angegebene Anzahl von Geräten erstellen?",
            "delete resource confirmation": {
                "first part": "Möchten Sie wirklich die angegebene Anzahl von {{resource}} löschen?",
                "second part": "Wenn ja, geben Sie die Anzahl der betroffenen {{resource}} ein und klicken Sie auf „Löschen“."
            },
            "delete resources": {
                "companies": "Unternehmen",
                "files": "Dateien",
                "groups": "Gerätegruppen",
                "deviceModels": "Modelle",
                "productCodes": "Produktcodes",
                "roles": "Rollen",
                "users": "Benutzer"
            },
            "description second part": "Wenn ja, geben Sie die Anzahl der betroffenen Geräte ein und klicken Sie auf „Bestätigen“.",
            "export device data confirmation": "Möchten Sie wirklich die Gerätedaten für die angegebene Anzahl von Geräten exportieren?",
            "file": "Geben Sie die Anzahl der Zeilen ein, die in der Datei vorhanden sind",
            "filter": {
                "companies": "Geben Sie die Anzahl der gefilterten Unternehmen ein",
                "devices": "Geben Sie die Anzahl der gefilterten Geräte ein",
                "files": "Geben Sie die Anzahl der gefilterten Dateien ein",
                "groups": "Geben Sie die Anzahl der gefilterten Gerätegruppen ein",
                "productCodes": "Geben Sie die Anzahl der gefilterten Produktcodes ein",
                "tasks": "Geben Sie die Anzahl der gefilterten Aufgaben ein",
                "users": "Geben Sie die Anzahl der gefilterten Benutzer ein"
            },
            "id_list": {
                "companies": "Geben Sie die Anzahl der ausgewählten Unternehmen ein",
                "devices": "Geben Sie die Anzahl der ausgewählten Geräte ein",
                "files": "Geben Sie die Anzahl der ausgewählten Dateien ein",
                "groups": "Geben Sie die Anzahl der ausgewählten Gerätegruppen ein",
                "productCodes": "Geben Sie die Anzahl der ausgewählten Produktcodes ein",
                "tasks": "Geben Sie die Anzahl der ausgewählten Aufgaben ein",
                "users": "Geben Sie die Anzahl der ausgewählten Benutzer ein"
            },
            "merge companies confirmation": "Sie sind dabei, die Unternehmen {{sourceCompany}} und {{targetCompany}} zusammenzuführen.",
            "move companies confirmation": "Sie sind dabei, {{sourceCompany}} zu {{targetCompany}} zu verschieben.",
            "move devices confirmation": "Sind Sie sicher, dass Sie die angegebene Anzahl von Geräten zu einem anderen Unternehmen verschieben möchten?",
            "number of lines": "Anzahl der Zeilen",
            "selected 20 or more devices": "Sie haben 20 oder mehr Geräte ausgewählt...",
            "transfer devices confirmation": "Sind Sie sicher, dass Sie die angegebene Anzahl von Geräten an ein anderes Unternehmen übertragen möchten?"
        },
        "confirm cannot revert": "Dieser Vorgang kann nicht rückgängig gemacht werden.",
        "confirm merge companies": "Sind Sie sicher, dass Sie diese Unternehmen zusammenführen möchten?",
        "count": "Zählen",
        "create company": "Unternehmen erstellen",
        "create company description": "Erstellen Sie ein neues Unternehmen unter der ausgewählten Muttergesellschaft.",
        "create desktop license": "Desktop-Lizenz erstellen",
        "create desktop license description": "Erteilen Sie dem Kundenunternehmen eine neue Online-FOTA-Desktop-Lizenz mit dessen IP-Adresse, Hardware-Schlüssel und Ablaufdatum (max. 2 Jahre).",
        "create group": "Gruppe erstellen",
        "create group description": "Organisieren Sie Geräte in Gruppen, um die Verwaltung zu vereinfachen und Massenzuweisungen vorzunehmen.",
        "create model": "Modell erstellen",
        "create model description": "Erstellen Sie ein neues Gerätemodell, indem Sie Name, Plattform und TCT web angeben.",
        "create offline license": "Offline-Lizenz erstellen",
        "create or edit group description": "Firmware und Konfiguration können der Gruppe zugewiesen werden. Sobald dies geschehen ist, werden Firmware- und/oder Konfigurationsaktualisierungsaufgaben für alle Gruppenmitglieder (Geräte) generiert.",
        "create role": "Rolle erstellen",
        "create role description": "Erstellen Sie eine neue Rolle, indem Sie ihr einen Namen und eine Beschreibung geben, ein Unternehmen auswählen und bestimmte Berechtigungen zuweisen.",
        "create smart group": "Intelligente Gruppe erstellen",
        "create smart group banner message": "",
        "create smart group description": "Firmware- und Konfigurationsdateien können der Gruppe für jede Plattform zugewiesen werden. Sobald die Dateien zugewiesen sind, werden Aktualisierungsaufgaben für alle Geräte der Gruppe generiert.",
        "create task description first step": "Erstellen Sie eine Vielzahl von Aufgaben, die von der Aktualisierung der Konfiguration oder Firmware bis zum Empfang von Protokollen, Konfigurationen und mehr von ausgewählten oder gefilterten Geräten reichen. Darüber hinaus können Sie erstellte Aufgaben nach Belieben planen.",
        "create task description last step": "Vergewissern Sie sich vor dem Erstellen der Aufgabe, dass die folgenden Informationen korrekt sind.",
        "current level": "Aktuelles Niveau",
        "custom resource limits": {
            "at least one limit must be higher": "Mindestens eine Grenze sollte höher sein als der Standardwert der Premium-Stufe.",
            "configuration files per device": "Konfigurationsdateien pro Gerät",
            "confirmation modal description": "Möchten Sie wirklich die folgenden Ressourcenbeschränkungen des Unternehmens „{{companyName}}“ ändern?",
            "confirmation modal title": "Änderung der Ressourcenbeschränkungen für Unternehmen?",
            "count": {
                "companies count": "Anzahl der Unternehmen: {{number}}",
                "configuration files per device count": "Konfigurationsdateien pro Gerät: {{number}}",
                "tasks per group count": "Aufgaben pro Gruppe: {{number}}",
                "users count": "Anzahl der Benutzer: {{number}}"
            },
            "explanations": {
                "companies": "Die Gesamtzahl der Tochterunternehmen, die in der Unternehmenshierarchie erstellt werden können.",
                "configuration files per device": "Die Anzahl der Konfigurationsdateien, die gespeichert werden können, entspricht 1 Gerät pro Konfigurationsdatei. Die garantierte Mindestanzahl an Konfigurationsdateien beträgt 100 pro Unternehmensebene.",
                "tasks per group": "Die Anzahl der Aufgaben, die in einer Aufgabengruppe enthalten sein können.",
                "users": "Die Gesamtzahl der Benutzer, die in der Unternehmenshierarchie angelegt werden können."
            },
            "main modal description": "Legen Sie eine benutzerdefinierte Menge an Ressourcen für verschiedene Ressourcentypen fest, z. B. Unternehmen, Benutzer, Aufgaben pro Aufgabengruppe oder Konfigurationsdateien. Benutzerdefinierte Ressourcen bleiben bis zum Ablauf der Premium-Stufe oder bis zum manuellen Zurücksetzen aktiv.",
            "resources limit type": "Art der Ressourcenbeschränkung",
            "revert custom resource limits": "Benutzerdefinierte Ressourcenbeschränkungen zurücksetzen",
            "revert custom resource limits description": "Durch das Zurücksetzen aller Limits werden die Standardressourcenwerte wiederhergestellt und die Unternehmensebene auf „Premium“ geändert.",
            "revert custom resource limits description confirmation": "Durch diese Aktion werden die Ressourcenbeschränkungen wieder auf die automatisch zugewiesenen Werte für die Stufe „Premium“ zurückgesetzt. Möchten Sie wirklich fortfahren?",
            "revert custom resource limits title": "Die Ressourcenbeschränkungen dieses Unternehmens wurden manuell festgelegt.",
            "revert custom resource limits title confirmation": "Benutzerdefinierte Ressourcenbeschränkungen zurücksetzen?",
            "tasks per group": "Aufgaben pro Gruppe"
        },
        "date range": "Datumsbereich",
        "date to": "zu",
        "delete companies": "Unternehmen löschen",
        "delete deviceModels": "Modelle löschen",
        "delete files": "Dateien löschen",
        "delete file warning": "Durch das Löschen von Dateien werden zugehörige Aufgaben und Aufgabengruppen gelöscht.",
        "delete groups": "Gerätegruppen löschen",
        "delete productCodes": "Produktcodes löschen",
        "delete roles": "Rollen löschen",
        "delete tasks and history": "",
        "delete users": "Benutzer löschen",
        "description": "Beschreibung",
        "desktop license delete description": "Möchten Sie die Desktop-Lizenz „{{name}}“ wirklich löschen?",
        "desktop license name": "Name der Desktop-Lizenz",
        "device identifier": "Gerätekennung",
        "device transfer": {
            "main": {
                "description": "Übertragen Sie ausgewählte oder gefilterte Geräte an ein unabhängiges Unternehmen, indem Sie ein vom empfangenden Unternehmen generiertes Token verwenden.",
                "title": "Geräteübertragung"
            },
            "receive devices": {
                "copy token": "Kopieren Sie das generierte Token und senden Sie es an die Person, die für die Übertragung der Geräte von ihrem Unternehmen zu Ihrem Unternehmen verantwortlich ist.",
                "description": "Erstellen Sie ein Token für das Empfangsgerät und senden Sie es an das Transferunternehmen.",
                "token info": "Das Token ist einmalig verwendbar und läuft nach 21 Tagen ab."
            },
            "transfer devices": {
                "confirmation": "Möchten Sie die Geräte wirklich an das unten angegebene Unternehmen übertragen?",
                "device token": "Das Gerätetransfer-Token muss vom Manager des Unternehmens angefordert werden, an das Sie Ihre Geräte übertragen möchten.",
                "transfer from file": "Laden Sie eine Datei mit einer Liste der Geräte (IMEIs) hoch, die Sie von Ihrem Unternehmen an das Unternehmen übertragen möchten, dessen Token Sie gerade eingegeben haben."
            }
        },
        "device transfer token": "Geräteübertragungstoken",
        "downgrading company level is not possible": "Ein Downgrade auf Unternehmensebene ist nicht möglich",
        "download sample file message": "Laden Sie eine <1>Beispiel-CSV-Vorlage</1> herunter, um ein Beispiel für das erforderliche Format zu sehen.",
        "edit group banner message": "Durch Ändern der Firmware und/oder Konfigurationsdateien werden alle zuvor ausstehenden Aufgaben desselben Typs abgebrochen.",
        "edit group description": "Ändern Sie die Einstellungen für diese Gerätegruppe.",
        "edit role description": "Anpassen von Rollennamen, Beschreibungen und Berechtigungen. Das zugewiesene Unternehmen kann nicht geändert werden.",
        "edit smart group description": "Firmware- und Konfigurationsdateien können der Gruppe für jede Plattform zugewiesen oder geändert werden. Sobald Dateien zugewiesen oder geändert wurden, werden Aktualisierungsaufgaben für alle Geräte der Gruppe generiert.",
        "email": "E-Mail",
        "enter": "Eingeben",
        "enter code": "Code eingeben",
        "enter description": "Beschreibung eingeben",
        "enter name": "Name eingeben",
        "example": "Beispiel:",
        "expires at": "Läuft ab am",
        "explanation": "Erläuterung",
        "export device data": "Gerätedaten exportieren",
        "export device description": "",
        "export file format": "Dateiformat exportieren",
        "feature": "Funktion",
        "feature control": "Funktionssteuerung",
        "field disabled until company selected": "Dieses Feld ist deaktiviert, bis das Unternehmen ausgewählt wurde.",
        "firmware": "Firmware",
        "files to download": "Dateien zum Herunterladen",
        "file upload": {
            "banner text": {
                "1_wire_authorization_list": "Die hochgeladene 1-Wire-Autorisierungsliste wird automatisch sortiert, um die Geschwindigkeit und Genauigkeit der Funktionalität zu verbessern.",
                "bluetooth_authorization_list": "Die hochgeladene Bluetooth-Autorisierungsliste wird automatisch sortiert, um die Geschwindigkeit und Genauigkeit der Funktionalität zu verbessern."
            },
            "endings": {
                "file": "Datei",
                "files": "Dateien"
            },
            "fail": {
                "multiple": "{{failCount}} von {{totalCount}} {{fileEnding}} konnten aufgrund eines Fehlers nicht hochgeladen werden.",
                "single": "{{failCount}} von {{totalCount}} {{fileEnding}} konnten aufgrund eines Fehlers nicht hochgeladen werden."
            },
            "success": {
                "multiple": "Alle Dateien wurden erfolgreich zu den ausgewählten Unternehmen hinzugefügt.",
                "single": "Alle Dateien wurden erfolgreich zum ausgewählten Unternehmen hinzugefügt."
            }
        },
        "filtered": "Gefiltert",
        "filtered companies": "Gefilterte Unternehmen",
        "filtered devices": "Gefilterte Geräte",
        "filtered files": "Gefilterte Dateien",
        "filtered groups": "Gefilterte Gruppen",
        "filtered tasks": "Gefilterte Aufgaben",
        "filtered users": "Gefilterte Benutzer",
        "find tool": {
            "device": {
                "error not valid": "Die IMEI muss aus 15 Zeichen bestehen",
                "error subtitle": "Gerät nicht gefunden. Bitte geben Sie eine andere IMEI ein.",
                "error title": "Kein Gerät gefunden",
                "link": "Zum Gerät gehen",
                "no permission": "Sie haben keine Berechtigung, dieses Gerät anzuzeigen."
            },
            "user": {
                "error not valid": "Ungültiges E-Mail-Format",
                "error subtitle": "Benutzer nicht gefunden. Bitte geben Sie eine andere Benutzer-E-Mail-Adresse ein.",
                "error title": "Kein Benutzer gefunden",
                "link": "Zum Benutzer",
                "no permission": "Sie haben keine Berechtigung, diesen Benutzer anzuzeigen."
            }
        },
        "firmware date": "Firmware-Datum",
        "from form": "Aus Formular",
        "from file": "Aus Datei",
        "general": "Allgemein",
        "gsm_number": "GSM-Nummer",
        "iccid": "ICCID",
        "imei": "IMEI",
        "imei restriction": "IMEI-Beschränkung",
        "import device data": "Gerätedaten importieren",
        "import device data description": "Importieren Sie ausgewählte Attributdaten für die Geräte in der bereitgestellten Liste.",
        "import device data info": "Jedes Attribut hat eine maximale Zeichenanzahl, die in Klammern angezeigt wird. Wenn ein Attribut mehr Zeichen als die maximale Anzahl hat, wird es automatisch auf die maximale Anzahl gekürzt.",
        "import device data limit": "(max. {{limit}} Zeichen)",
        "imsi": "IMSI",
        "input text too long": "Der Text ist zu lang. Maximal {{maxLength}} Zeichen sind zulässig.",
        "invalid hardware key": "Ungültiges Hardware-Schlüsselformat",
        "invalid imei": "IMEI ist ungültig",
        "invalid ipv4": "Ungültiges IPv4-Format",
        "invalid serial": "Ungültige Seriennummer",
        "invalid value": "Ungültiger Wert",
        "inverted selection": "Umgekehrte Auswahl",
        "invite user": "Benutzer einladen",
        "invite user description": "Laden Sie einen neuen Benutzer zur ausgewählten Muttergesellschaft ein und legen Sie dessen Rolle fest. Nach dem Absenden hat der Benutzer 30 Tage Zeit, die Einladung anzunehmen, bevor sie abläuft.",
        "invite user max roles": "Maximal 5 Rollen zulässig. Deaktivieren Sie eine, um fortzufahren.",
        "log files": "Logdateien",
        "make": "Erstellen",
        "manage permissions": "Verwalten Sie alle Daten auf Konto- und Website-Ebene.",
        "maximum value is": "Der maximale Wert beträgt {{value}}",
        "merge companies": "Unternehmen zusammenführen",
        "merge companies info": "Alle Ressourcen des Quellunternehmens (Geräte, Gruppen, Dateien, Unternehmen, Benutzer mit ihren Rollen) werden zum Zielunternehmen übertragen. Möglicherweise möchten Sie die Benutzerrollen vor der Zusammenführung überprüfen. Das Quellunternehmen wird anschließend gelöscht.",
        "merge companies disabled option": {
            "client to internal": "Kundenunternehmen können nicht mit internen Unternehmen zusammengeführt werden.",
            "internal": "Interne Unternehmenstypen können nicht zusammengeführt werden.",
            "lz code": "Unternehmen mit Code können nicht zusammengeführt werden."
        },
        "minimum value is": "Der Mindestwert beträgt {{value}}",
        "move companies disabled option": {
            "internal": "Internes Unternehmen kann nicht verlegt werden."
        },
        "move device": "Gerät verschieben",
        "move device description": "Verschieben Sie ausgewählte oder gefilterte Geräte in das bestehende Unternehmen und/oder die Gruppe in der Unternehmenshierarchie.",
        "move device group": "",
        "move device group banner": "",
        "move device group description": "",
        "move devices": "Geräte verschieben",
        "name": "Name",
        "newest": "Aus den neuesten",
        "no dropdown files": {
            "description": "Um diese Option auszuwählen, laden Sie eine neue $t(Dialog##no dropdown files##file names##{{fileName}})-Datei hoch.",
            "description no permission create file": "",
            "file names": {
                "1_wire_authorization_list": "1-Wire-Autorisierungsliste",
                "adas_firmware": "ADAS-Firmware",
                "ble_fw": "BLE-Firmware",
                "blue_nrg": "BlueNrg-Firmware",
                "bluetooth_authorization_list": "Bluetooth-Autorisierungsliste",
                "can_chip_firmware": "FM CAN Chip-Firmware",
                "carrier_advance_firmware": "Carrier Advance-Firmware",
                "carrier_advance_settings": "Carrier Advance Einstellungen",
                "carrier_apx_firmware": "Carrier APX-Firmware",
                "carrier_apx_settings": "Carrier APX-Einstellungen",
                "certificate": "TLS-Zertifikat",
                "configuration": "Konfiguration",
                "dsm_firmware": "DSM-Firmware",
                "dtb": "DTB",
                "firmware": "Firmware",
                "fw_bundle": "Firmware-Paket",
                "gnssm_download_assistant": "GNSS-M Download Assistant",
                "gnssm_firmware": "GNSS-M-Firmware",
                "main configuration": "",
                "manual_geofence_list": "Liste manueller Geofence-Szenarien",
                "meig_modem_firmware": "MeiG-Modem-Firmware",
                "netprisma_modem_firmware": "NETPRISMA-Modem-Firmware",
                "psub": "Abonnement",
                "quectel_modem_firmware": "Quectel-Modem-Firmware",
                "simcom_modem_firmware": ""
            },
            "main": "Es gibt keine $t(Dialog##no dropdown files##file names##{{fileName}})-Dateien."
        },
        "none": "Keine",
        "obd oem": "OBD OEM",
        "offline license delete description": "Möchten Sie die Offline-Lizenz „{{name}}“ wirklich löschen?",
        "oldest": "Von ältesten",
        "only integers": "Nur ganze Zahlen sind gültig",
        "only numbers": "Nur Zahlen sind gültig",
        "optional": "optional",
        "other companies": "Andere Unternehmen",
        "parent company": "Muttergesellschaft",
        "permission preset": "Voreingestellte Berechtigungen",
        "platform compatibility": {
            "banner text": "Einige der ausgewählten Gerätemodelle sind mit dem ausgewählten Aufgabentyp nicht kompatibel. Dieser Aufgabentyp wird für inkompatible Gerätemodelle standardmäßig nicht erstellt.",
            "compatible model devices": "Kompatible Gerätemodelle",
            "count text": "Die Aufgabe wird für <1>{{compatibleCount}}</1> von {{totalCount}} Geräten erstellt.",
            "create tasks for incompatible devices": "Erstellen Sie Aufgaben für inkompatible Geräte.",
            "devices from file": "Geräte aus Datei",
            "platform": "{{title}}-Plattform",
            "task applies": "Aufgabe gilt für",
            "task cannot be created": "Für inkompatible Gerätemodelle können keine Aufgaben erstellt werden."
        },
        "receiving company": "Dieses Unternehmen erhält Ihre Geräte",
        "resend user invitation": "",
        "retry tasks in group": {
            "alert title": "Dieser Vorgang kann bis zu mehreren Minuten dauern.",
            "banner description": "Um den aktualisierten Status von Aufgaben anzuzeigen, sehen Sie sich bitte die Details der Aufgabengruppe an oder aktualisieren Sie die Seite.",
            "description": "Durch Klicken auf „Akzeptieren“ werden alle fehlgeschlagenen Aufgaben erneut versucht. Möchten Sie wirklich fortfahren?",
            "title": "Alle Aufgaben in der Gruppe erneut versuchen?"
        },
        "revision": "Überarbeitung",
        "revision value error": "Der Wert muss zweistellig sein (00–99).",
        "role name": "Rollenname",
        "root company": "Muttergesellschaft",
        "sales email": "E-Mail des Vertriebsleiters",
        "scheduled time warning": "Aufgaben mit festgelegter Zeit ändern nichts an der Konfiguration der FOTA-Verbindungszeit des Geräts. Die Aufgaben werden ausgeführt, wenn das Gerät während des ausgewählten Zeitfensters eine Verbindung zu FOTA WEB herstellt. Bitte stellen Sie sicher, dass die Geräte so konfiguriert sind, dass sie sich mindestens während des ausgewählten Zeitfensters mit FOTA WEB verbinden.",
        "schedule task": "Aufgaben planen",
        "select": "Auswählen",
        "select at least one": {
            "companies": "Bitte wählen Sie mindestens ein Unternehmen aus",
            "devices": "Bitte wählen Sie mindestens ein Gerät aus",
            "files": "Bitte wählen Sie mindestens eine Datei aus",
            "groups": "Bitte wählen Sie mindestens eine Gruppe aus",
            "tasks": "Bitte wählen Sie mindestens eine Aufgabe aus",
            "users": "Bitte wählen Sie mindestens einen Benutzer aus"
        },
        "selected": "Ausgewählt",
        "selected companies": "Ausgewählte Unternehmen",
        "selected deviceModels": "Ausgewählte Modelle",
        "selected devices": "Ausgewählte Geräte",
        "selected files": "Ausgewählte Dateien",
        "selected groups": "Ausgewählte Gerätegruppen",
        "selected productCodes": "Ausgewählte Produktcodes",
        "selected roles": "Ausgewählte Rollen",
        "selected tasks": "Ausgewählte Aufgaben",
        "selected users": "Ausgewählte Benutzer",
        "select company": "",
        "select group": "",
        "select time interval": "Zeitintervall auswählen",
        "selected time window": "Ausgewähltes Zeitfenster: {{fromDate}} bis {{toDate}}",
        "set bluetooth password": {
            "bluetooth password": "",
            "repeat bluetooth password": "",
            "enter password": "",
            "password source": "",
            "rules": {
                "allowed characters": "",
                "characters length": "",
                "passwords must match": ""
            },
            "SystemGenerated": {
                "description": ""
            },
            "UserEntered": {
                "description": ""
            }
        },
        "show files for selected companies only": "",
        "smart group": {
            "description": "Wählen Sie verfügbare Dateien für Geräte der Plattform {{platformName}} aus.",
            "title": "{{platformName}} Plattformdateien"
        },
        "sn": "Seriennummer.",
        "specific": "Spezifisch",
        "time period": "Zeitraum",
        "time period custom": "Kundenspezifisch",
        "tls certificate transfer info": "",
        "token has expired": "Das Token ist abgelaufen",
        "token is valid": "Token ist gültig",
        "transfer companies": "Transferunternehmen",
        "transfer companies description": "Wählen Sie aus, ob Sie zwei Unternehmen verschieben oder zusammenführen möchten. Einige Optionen sind irreversibel.",
        "transfer devices": "Geräte übertragen",
        "tri source": {
            "selected tab description": {
                "create task": "Die ausgewählte Aufgabe wird für die über das Kontrollkästchen ausgewählten Geräte erstellt.",
                "general": "Die ausgewählte Aktion wird für die über das Kontrollkästchen ausgewählten Geräte ausgeführt."
            },
            "filtered tab description": {
                "create task": "Die ausgewählte Aufgabe wird für gefilterte Geräte unter Verwendung eines oder mehrerer verfügbarer Filter erstellt.",
                "general": "Die ausgewählte Aktion wird für gefilterte Geräte unter Verwendung eines oder mehrerer verfügbarer Filter ausgeführt."
            },
            "from file tab description": {
                "create task": "Die ausgewählte Aufgabe wird für Geräte erstellt, die in der hochgeladenen Datei angegeben wurden.",
                "general": "Die ausgewählte Aktion wird für die Geräte ausgeführt, die in der hochgeladenen Datei angegeben wurden."
            }
        },
        "unlocker": {
            "generate unlock key": "Entsperrschlüssel generieren",
            "generate unlock key description": "Geben Sie den „Sperrcode“ des Geräts aus TCT in das untenstehende Feld ein. Klicken Sie auf die Schaltfläche „Generieren“, um einen Entsperrcode zu generieren, und verwenden Sie diesen in TCT, um Ihr Gerät zu entsperren.",
            "invalid lock code": "Ungültiger Gerätesperrcode.",
            "limit reached": "Sie haben die maximale Anzahl generierter Entsperrschlüssel erreicht.",
            "lock code": "Sperrcode",
            "select device platform": "Geräteplattform auswählen",
            "select device platform description": "Wählen Sie die richtige Geräteplattform aus. Telematikgeräte werden in drei Plattformgenerationen unterteilt: <1>FT</1> (FTx, ATx), <2>FMx</2> (verschiedene FM-, FMT-, TAT-, MSP-, TFT-, TST-, GH- und TMT-Modelle) und <3>Legacy</3> (ältere FM-, FMA- und GH-Modelle).",
            "unlock key": "Entsperrschlüssel",
            "unlock key success message": "Schlüssel erfolgreich generiert."
        },
        "upload file": "Datei hochladen",
        "upload file description": "Laden Sie bis zu {{count}} Dateien gleichzeitig hoch, indem Sie sie per Drag & Drop verschieben oder auswählen.",
        "upload firmware bundle container info": "",
        "upload firmware downgrade protection info": "Die Firmware-Versionen 04.00.00 und höher enthalten einen Downgrade-Schutz. Weitere Informationen zu Firmware-Änderungen finden Sie in unserer Dokumentation unter <1>Teltonika GPS Wiki</1>. Durch Klicken auf die Schaltfläche „Weiter“ erklären Sie sich mit den oben genannten Informationen einverstanden und bestätigen, dass Sie diese verstanden haben.",
        "upload firmware unsupported info": "Ein Update auf diese Version ist nicht verfügbar. Bitte wenden Sie sich an den Teltonika-Support oder Ihren Teltonika-Vertriebsleiter.",
        "use at least one filter": "Bitte verwenden Sie mindestens einen Filter",
        "user": "Benutzer",
        "valid until": "Gültig bis",
        "valid until date disable description": "Dieses Feld kann nur geändert werden, wenn der Zeitraum auf „Benutzerdefiniert“ eingestellt ist",
        "vehicle model": "Modell"
    },
    "Dropzone": {
        "add file": "Datei hinzufügen",
        "add files": "Dateien hinzufügen",
        "drop file to upload": "Legen Sie die Datei zum Hochladen ab",
        "drop files to upload": "Dateien zum Hochladen ablegen",
        "error uploading the file": "Beim Hochladen der Datei ist ein Fehler aufgetreten",
        "file invalid type": "Ungültiger Dateityp ausgewählt.",
        "file successfully uploaded": "Datei erfolgreich hochgeladen",
        "file syntax": "Die Dateisyntax lautet wie folgt:",
        "invalid format or size": "",
        "max file size": "",
        "maximum file limit reached": "Die maximale Dateigröße wurde erreicht.",
        "only one file can be attached": "Es kann nur eine Datei angehängt werden.",
        "or drop file to upload": "Oder Datei zum Hochladen ablegen",
        "or drop files to upload": "Oder Dateien zum Hochladen ablegen",
        "rows detected": "Zeilen in der Datei erfolgreich erkannt",
        "select file": "Datei auswählen",
        "select files": "Dateien auswählen",
        "select file type": "Bitte wählen Sie zuerst den Dateityp aus.",
        "supported formats": "Unterstützte Formate",
        "too long file name": "Der Dateiname ist zu lang. Maximal {{maxLength}} Zeichen sind zulässig.",
        "too many files description": "Die restlichen Dateien können hochgeladen werden, nachdem Sie die ausgewählten Dateien hochgeladen haben.",
        "too many files title": "Es gibt eine maximale Dateigröße von {{maxFiles}}, die Sie gleichzeitig anhängen können."
    },
    "Error": {
        "error": "Fehler",
        "message wait": "Bitte haben Sie etwas Geduld, bis wir den Fehler behoben haben.",
        "title": "Etwas ist schiefgelaufen!"
    },
    "Feature highlight": {
        "got it": "Verstanden",
        "new feature": "Neue Funktion!",
        "scenarios description": "Jetzt können Sie eines der folgenden Szenarien auf Ihrem Gerät einstellen: Geschwindigkeitsüberschreitung, Unfallerkennung oder Abschlepperkennung."
    },
    "Filter": {
        "access group": "",
        "activity_status": "Status",
        "all permissions": "Alle Berechtigungen",
        "batch_id": "Batch-ID",
        "company_id": "Unternehmen",
        "company selector": "",
        "configuration change origin": "",
        "configuration_file_id": "",
        "configuration type": "",
        "created_by": "Erstellt von",
        "current_configuration": "Konfiguration",
        "current_firmware": "Firmware",
        "device_imei": "Geräte-IMEI",
        "file type": "Dateityp",
        "filtered by": "Gefiltert nach",
        "filters used": "Verwendete Filter",
        "firmware_file_id": "",
        "ft_bluetooth_auth_list_file_id": "",
        "ft_configuration_file_id": "",
        "ft_firmware_file_id": "",
        "ft_one_wire_auth_list_file_id": "",
        "group_id": "Gruppe",
        "id": "ID",
        "Invalid company": "Ungültiges Unternehmen",
        "model": "Modell",
        "model_platform": "Plattform",
        "Multiple companies": "Mehrere Unternehmen",
        "parent company": "Muttergesellschaft",
        "permission": "Berechtigung",
        "permission status": "Status",
        "role": "Rolle",
        "spec_id": "Spec ID",
        "status_id": "Status",
        "supported_task_type": "Aufgabentyp",
        "table filters": "Tabellenfilter",
        "task type": "Aufgabentyp",
        "task_queue": "Warteschlange",
        "type": "Typ",
        "user status": "Status"
    },
    "Flash": {
        "account was deleted": "",
        "ADAS firmware file size can't be zero": "Die Größe der ADAS-Firmware-Datei darf nicht Null sein.",
        "ADAS firmware is invalid.": "Die ADAS-Firmware ist ungültig.",
        "All notifications were deleted.": "Alle Benachrichtigungen wurden gelöscht.",
        "All notifications were marked as read.": "Alle Benachrichtigungen wurden als gelesen markiert.",
        "At least one user role must be provided.": "Es muss mindestens eine Benutzerrolle bereitgestellt werden.",
        "Attributes length is invalid": "Die Länge der Attribute ist ungültig.",
        "Banner was updated.": "",
        "Batch was discarded": "Der Stapel wurde verworfen.",
        "Bulk attribute update job was created. Devices' attributes will be updated shortly.": "Ein Job zur Massenaktualisierung von Attributen wurde erstellt. Die Attribute der Geräte werden in Kürze aktualisiert.",
        "Bulk create job was created. Devices will be created shortly.": "Ein Massenjob wurde erstellt. Die Geräte werden in Kürze erstellt.",
        "Bulk create job was created. Tasks will be created shortly.": "Ein Massenauftrag wurde erstellt. Die Aufgaben werden in Kürze erstellt.",
        "Bulk delete job was created. Companies will be removed shortly.": "Ein Massenlöschauftrag wurde erstellt. Die Unternehmen werden in Kürze entfernt.",
        "Bulk delete job was created. Devices will be removed shortly.": "Ein Massenlöschauftrag wurde erstellt. Die Geräte werden in Kürze entfernt.",
        "Bulk delete job was created. Files will be removed shortly.": "Ein Massenlöschauftrag wurde erstellt. Die Dateien werden in Kürze entfernt.",
        "Bulk delete job was created. Groups will be removed shortly.": "Ein Massenlöschauftrag wurde erstellt. Die Gruppen werden in Kürze entfernt.",
        "Bulk delete job was created. Product codes will be removed shortly.": "Ein Massenlöschauftrag wurde erstellt. Die Produktcodes werden in Kürze entfernt.",
        "Bulk delete job was created. Users will be removed shortly.": "Ein Massenlöschauftrag wurde erstellt. Die Benutzer werden in Kürze entfernt.",
        "Bulk task create job was created. Tasks will be created shortly.": "Eine Massenaufgabe wurde erstellt und die Aufgaben werden in Kürze angezeigt. Die Aufgaben finden Sie auf der Seite „Aufgabengruppen“ unter „Aufgabengruppendetails“.",
        "Bulk update job was created. Devices will be updated shortly.": "Ein Massenaktualisierungsauftrag wurde erstellt. Die Geräte werden in Kürze aktualisiert.",
        "Bulk update job was created. Tasks will be updated shortly.": "Ein Massenaktualisierungsauftrag wurde erstellt. Die Aufgaben werden in Kürze aktualisiert.",
        "Can adapter was added.": "Ein Adapter kann hinzugefügt werden.",
        "Can adapter was deleted.": "Der Adapter wurde gelöscht.",
        "Can adapter was updated.": "Der Adapter wurde aktualisiert.",
        "Can chip firmware file size can't be zero": "Die Dateigröße der Chip-Firmware darf nicht Null sein.",
        "Can chip firmware is invalid.": "Die Chip-Firmware ist möglicherweise ungültig.",
        "Cannot delete company. Company is not empty.": "Unternehmen kann nicht gelöscht werden. Unternehmen ist nicht leer.",
        "Cannot delete file. It is used by pending or running tasks.": "Datei kann nicht gelöscht werden. Sie wird für ausstehende oder laufende Aufgaben verwendet.",
        "Cannot delete file. It is used by running tasks.": "Datei kann nicht gelöscht werden. Sie wird von laufenden Aufgaben verwendet.",
        "Cannot delete file. There are tasks waiting for approval.": "",
        "Cannot delete product code assigned to devices.": "Der den Geräten zugewiesene Produktcode kann nicht gelöscht werden.",
        "check your email for details": "",
        "Companies count limit exceeded.": "Die Anzahl der Unternehmen wurde überschritten.",
        "Companies in the request must belong to the selected root.": "Die Unternehmen in der Anfrage müssen zur ausgewählten Wurzel gehören.",
        "Company merge job was created. It will be merged shortly.": "Der Auftrag zur Unternehmensfusion wurde erstellt. Die Fusion wird in Kürze durchgeführt.",
        "Company name already exist.": "Der Name des Unternehmens existiert bereits.",
        "Company level change is not allowed.": "Änderungen auf Unternehmensebene sind nicht zulässig.",
        "Company level successfully changed": "Unternehmensebene erfolgreich geändert.",
        "company level successfully reverted": "Die Unternehmensebene wurde erfolgreich auf die automatisch zugewiesene Ebene zurückgesetzt.",
        "Company not allowed to be merged": "Das Unternehmen darf nicht fusioniert werden.",
        "company resource limits changed": "Die Ressourcenbeschränkungen des Unternehmens wurden erfolgreich geändert.",
        "Company was created.": "Das Unternehmen wurde gegründet.",
        "Company was deleted.": "Das Unternehmen wurde gelöscht.",
        "Company was updated.": "Das Unternehmen wurde aktualisiert.",
        "compatibilities added": "{{count}} neue Kompatibilitäten wurden während der Synchronisierung hinzugefügt.",
        "compatibilities synchronized": "Fehlende Kompatibilitäten wurden erfolgreich synchronisiert.",
        "Configuration cannot have FOTA functionality disabled": "Die Konfiguration darf keine deaktivierte FOTA-Funktionalität aufweisen.",
        "Configuration file cannot contain duplicate parameters": "Die Konfigurationsdatei darf keine doppelten Parameter enthalten.",
        "Configuration file size can't be zero": "Die Größe der Konfigurationsdatei darf nicht Null sein.",
        "Configuration files count limit exceeded.": "Die Anzahl der Konfigurationsdateien wurde überschritten.",
        "Configuration version must be defined": "Die Konfigurationsversion muss definiert werden.",
        "custom resource limits successfully reverted": "Benutzerdefinierte Ressourcenbeschränkungen wurden erfolgreich auf automatisch zugewiesene Beschränkungen zurückgesetzt.",
        "Custom roles feature is not enabled.": "Die Funktion für benutzerdefinierte Rollen kann nur von Benutzern mit Premium-Unternehmensstatus verwendet werden. Zuvor erstellte benutzerdefinierte Rollen können gelöscht werden.",
        "desktop license added": "Die Desktop-Lizenz „{{name}}“ wurde erfolgreich hinzugefügt.",
        "Devices already are in target company": "Die Geräte befinden sich bereits im Zielunternehmen.",
        "Device already exists.": "Das Gerät existiert bereits.",
        "Device bulk attribute update file cannot be empty": "Die Datei für die Massenaktualisierung von Geräteattributen darf nicht leer sein.",
        "Device bulk attribute update file should be .csv": "Die Datei für die Massenaktualisierung von Geräteattributen sollte im CSV-Format vorliegen.",
        "Device export limit reached. You can not export more than 100000 devices": "Das Exportlimit für Geräte wurde erreicht. Sie können nicht mehr als 100.000 Geräte exportieren.",
        "Device import limit reached. You can not import more than 100 devices": "Das Importlimit für Geräte wurde erreicht. Sie können nicht mehr als 100 Geräte importieren.",
        "Device model and task type compatibility was updated.": "Die Kompatibilität von Gerätemodellen und Aufgabentypen wurde aktualisiert.",
        "Device model was created.": "Das Gerätemodell wurde erstellt.",
        "Device model was deleted.": "Das Gerätemodell wurde gelöscht.",
        "Device model was updated.": "Das Gerätemodell wurde aktualisiert.",
        "Device not found": "Gerät nicht gefunden.",
        "Device Transfer job was created. Devices will be transfered shortly.": "Der Geräteübertragungsauftrag wurde erstellt. Die Geräte werden in Kürze übertragen.",
        "Device was added.": "Gerät wurde hinzugefügt.",
        "Device was deleted.": "Das Gerät wurde gelöscht.",
        "Device was updated.": "Das Gerät wurde aktualisiert.",
        "Email or password is incorrect.": "Die von Ihnen eingegebene E-Mail-Adresse oder das Passwort ist falsch.",
        "Failed to create Product code": "Produktcode konnte nicht erstellt werden.",
        "Failed to delete Product code": "Das Löschen des Produktcodes ist fehlgeschlagen.",
        "Failed to import devices.": "Import der Geräte fehlgeschlagen.",
        "Failed to Read Product code": "Produktcode konnte nicht gelesen werden.",
        "Failed to retry failed tasks": "Fehlgeschlagene Aufgaben konnten nicht erneut ausgeführt werden.",
        "Failed to update Product code": "Aktualisierung des Produktcodes fehlgeschlagen.",
        "Failed to update task for retry": "Wiederholungsversuch für fehlgeschlagene Aufgabe fehlgeschlagen.",
        "Field is not valid": "Das Feld ist ungültig.",
        "File description is too long. Max 255 characters allowed.": "Die Dateibeschreibung ist zu lang. Maximal 255 Zeichen sind zulässig.",
        "File exceeds entries limit of 10000.": "Die Datei überschreitet die Eingabegrenze von 10.000.",
        "File must not contain duplicated IMEIs": "Die Datei darf keine doppelten IMEIs enthalten.",
        "File must not contain IMEIs that already exist in database.": "Die Datei darf keine IMEIs enthalten, die bereits in der Datenbank vorhanden sind.",
        "File must not contain invalid IMEIs": "Die Datei darf keine ungültigen IMEIs enthalten.",
        "File name is too long. Max 255 characters allowed.": "Der Dateiname ist zu lang. Maximal 255 Zeichen sind zulässig.",
        "File name should not contain illegal characters or symbols": "Der Dateiname darf keine Sonderzeichen enthalten.",
        "File not found": "Datei nicht gefunden.",
        "File was deleted.": "Die Datei wurde gelöscht.",
        "File was successfully uploaded.": "Die Datei wurde erfolgreich hochgeladen.",
        "File was updated.": "Die Datei wurde aktualisiert.",
        "File was uploaded. Devices will be imported shortly.": "Die Datei wurde hochgeladen. Die Geräte werden in Kürze importiert.",
        "File will be created shortly. Check files in a second.": "Die Datei wird in Kürze erstellt. Überprüfen Sie die Dateien in einer Sekunde.",
        "Firmware already exists in global files.": "",
        "Firmware bundle already exists in global files.": "",
        "Firmware file size can't be zero": "Die Größe der Firmware-Datei darf nicht Null sein.",
        "First device in file not found.": "Erstes Gerät in der Datei nicht gefunden.",
        "Forbidden": "Verboten.",
        "Group name already exist.": "Der Gruppenname existiert bereits.",
        "Group was added.": "„{{group}}“ wurde erfolgreich erstellt.",
        "Group was created.": "Gruppe wurde erstellt.",
        "Group was deleted.": "Gruppe wurde gelöscht.",
        "Group was updated.": "Gruppe wurde aktualisiert.",
        "Invalid device bulk update attribute": "Ungültiges Attribut für die Massenaktualisierung von Geräten.",
        "Invalid email address.": "Ungültige E-Mail-Adresse.",
        "Invalid file contents": "Ungültiger Dateiinhalt.",
        "Invalid file name": "Ungültiger Dateiname.",
        "Invalid invitation token.": "Ungültiger Einladungstoken.",
        "Invalid token": "Ungültiges Token.",
        "Invalid token length": "Ungültige Token-Länge.",
        "Internal Server Error": "Interner Serverfehler.",
        "Internal users must sign in using Microsoft Entra ID.": "",
        "License was deleted.": "Die Lizenz wurde gelöscht.",
        "License was updated.": "Die Lizenz wurde aktualisiert.",
        "Maximum companies hierarchy depth exceeded": "Maximale Hierarchietiefe des Unternehmens überschritten",
        "Maximum device group size exceeded.": "Die maximale Größe der Gerätegruppe wurde überschritten.",
        "Method Not Allowed": "Methode nicht zulässig.",
        "Network Error": "Netzwerkfehler.",
        "No changes made": "Es wurden keine Änderungen vorgenommen.",
        "No resources found.": "Keine Ressourcen gefunden.",
        "not allowed to affect batch": {
            "description": "Bitte stellen Sie sicher, dass Sie die Kontrolle über das Unternehmen des Benutzers haben, der diese Aufgabengruppe erstellt hat.",
            "title": {
                "approve": "Sie haben keine Berechtigung, diesen Stapel zu genehmigen.",
                "discard": "Sie haben keine Berechtigung, diesen Stapel zu verwerfen."
            }
        },
        "Not Found": "Nicht gefunden.",
        "Notification was deleted.": "Die Benachrichtigung wurde gelöscht.",
        "notify when done title": "Dies kann einen Moment dauern. Klicken Sie auf die Schaltfläche unten, um diesen Bildschirm zu schließen. Sie erhalten eine Benachrichtigung, sobald der Vorgang abgeschlossen ist.",
        "Obd record was created.": "OBD-Datensatz wurde erstellt.",
        "Obd record was updated.": "OBD-Datensatz wurde aktualisiert.",
        "offline license added": "Die Offline-Lizenz „{{name}}“ wurde erfolgreich hinzugefügt.",
        "Offline license was deleted.": "Die Offline-Lizenz wurde gelöscht.",
        "Only id_list source is supported.": "Es wird nur die Quelle „id_list“ unterstützt.",
        "Only users with Teltonika email can be invited into internal companies.": "Nur Benutzer mit einer Teltonika-E-Mail-Adresse können zu internen Unternehmen eingeladen werden.",
        "Only users with Teltonika email can be moved into internal companies.": "Nur Benutzer mit einer Teltonika-E-Mail-Adresse können in interne Unternehmen verschoben werden.",
        "Parent company cannot be a descendant of the updated company.": "Die Muttergesellschaft darf kein Nachkomme des aktualisierten Unternehmens sein.",
        "Password reset link was sent to Your email.": "Der Link zum Zurücksetzen Ihres Passworts wurde an Ihre E-Mail-Adresse gesendet.",
        "Password reset token is invalid, expired or related user no longer exists.": "Das Token zum Zurücksetzen des Passworts ist ungültig, abgelaufen oder der Benutzer existiert nicht mehr.",
        "Password was changed.": "Das Passwort wurde geändert.",
        "product code added": "Der Produktcode „{{code}}“ wurde erfolgreich hinzugefügt.",
        "Product code is too long. Max 200 characters allowed.": "Der Produktcode ist zu lang. Maximal 200 Zeichen sind zulässig.",
        "ProductCode already exists.": "Produktcode bereits vorhanden.",
        "ProductCode not found": "Produktcode nicht gefunden.",
        "Product code was deleted.": "Der Produktcode wurde gelöscht.",
        "Product code was updated.": "Der Produktcode wurde aktualisiert.",
        "Retry failed tasks job was created": "Job zum Wiederholen fehlgeschlagener Aufgaben wurde erstellt.",
        "Role cannot be set for an internal user.": "Für interne Benutzer kann keine Rolle festgelegt werden.",
        "Role was created.": "Rolle wurde erstellt.",
        "Role was deleted.": "Die Rolle wurde gelöscht.",
        "Role was updated.": "Die Rolle wurde aktualisiert.",
        "selected company changed": "Das ausgewählte Unternehmen wurde geändert.",
        "Selected firmware bundle is not supported by the device.": "Das ausgewählte Firmware-Paket wird vom Gerät nicht unterstützt.",
        "Server Error": "Serverfehler.",
        "SMS was sent.": "SMS wurde gesendet.",
        "Something went wrong while saving a new password.": "Beim Speichern eines neuen Passworts ist ein Fehler aufgetreten.",
        "Successfully logged out.": "Erfolgreich abgemeldet.",
        "System Admin user level is required in order to perform this action.": "Um diese Aktion ausführen zu können, ist eine Benutzerberechtigung auf Systemadministrator-Ebene erforderlich.",
        "Target company cannot be a descendant of source company.": "Das Zielunternehmen darf kein Nachkomme des Quellunternehmens sein.",
        "Task create limit exceeded.": "Sie können keine Aufgabengruppe für mehr als 100.000 Geräte erstellen.",
        "Task type is not retriable": "Der Aufgabentyp kann nicht wiederholt werden",
        "Task was added.": "Aufgabe wurde hinzugefügt.",
        "task was created": "Die Aufgabe wurde für {{imei}} („{{taskType}}“) erstellt. Die Aufgabe finden Sie auf der Seite „Geräte“ unter „Aufgaben“ in den Gerätedetails.",
        "Task was updated.": "Die Aufgabe wurde aktualisiert.",
        "Tasks were approved": "Die Aufgaben wurden genehmigt.",
        "The given data was invalid.": "Die angegebenen Daten waren ungültig.",
        "time zone changed": "Die Zeitzone wurde geändert.",
        "Token cannot be null or empty": "Das Token darf nicht null oder leer sein.",
        "token created": "API-Token wurde erfolgreich erstellt.",
        "Token has expired": "Das Token ist abgelaufen.",
        "Token's and token's owner companies do not match": "Die Token und die Unternehmen, denen die Token gehören, stimmen nicht überein.",
        "Token was deleted.": "Token wurde gelöscht.",
        "Too many resources in the request": "Zu viele Ressourcen in der Anfrage",
        "Too Many Requests": "Zu viele Anfragen.",
        "Transfer token created": "Übertragungstoken erstellt.",
        "tutorial completed": "",
        "Two factor authentication is already activated for the user.": "Die Zwei-Faktor-Authentifizierung ist für den Benutzer bereits aktiviert.",
        "Two factor authentication successfully disabled.": "Zwei-Faktor-Authentifizierung erfolgreich deaktiviert.",
        "Unable to send SMS. This device does not have a GSM number assigned.": "SMS können nicht gesendet werden. Diesem Gerät ist keine GSM-Nummer zugewiesen.",
        "Unable to validate Your request.": "Ihre Anfrage kann nicht validiert werden.",
        "Unauthenticated.": "Nicht authentifiziert.",
        "Unauthorized": "Nicht autorisiert.",
        "User access level is not valid": "Benutzerzugriffsebene ist ungültig",
        "User invitation was revoked": "Einladung erfolgreich storniert.",
        "User invitation was re-sent": "Die Einladung für den Benutzer wurde erneut gesendet.",
        "User is already in the system.": "Der Benutzer ist bereits im System angemeldet.",
        "User was created.": "Benutzer wurde erstellt.",
        "User was deleted.": "Benutzer wurde gelöscht.",
        "User was invited.": "Benutzereinladung erfolgreich gesendet.",
        "User was updated": "Benutzer wurde aktualisiert.",
        "Users count limit exceeded.": "Die maximale Anzahl an Benutzern wurde überschritten.",
        "Your password has been changed.": "Ihr Passwort wurde geändert."
    },
    "General": {
        "0": "Benutzer",
        "5": "Support",
        "10": "Admin",
        "15": "Admin-Manager",
        "19": "",
        "20": "Systembenutzer",
        "99": "Superuser",
        "--- START-OF-PERMISSIONS ---": "",
        "Company.Create": "Unternehmen erstellen",
        "Company.Delete": "Unternehmen löschen",
        "Company.Merge": "Unternehmensfusion",
        "Company.Update": "Unternehmensupdate",
        "Device.Export": "Geräteexport",
        "Device.Read": "Geräte lesen",
        "Device.SecretsRead": "",
        "Device.Transfer": "Geräteübertragung",
        "Device.Unlock": "Geräteentsperrung",
        "Device.Update": "Geräte-Update",
        "DeviceGroup.Create": "Gerätegruppe erstellen",
        "DeviceGroup.Delete": "Gerätegruppe löschen",
        "DeviceGroup.Read": "Lesen von Gerätegruppen",
        "DeviceGroup.Update": "Aktualisierung von Gerätegruppen",
        "File.Create": "Datei erstellen",
        "File.Delete": "Dateien löschen",
        "File.Download": "Datei-Download",
        "File.Read": "Datei lesen",
        "File.TctWebAccess": "TCT web",
        "File.Update": "Dateiaktualisierung",
        "Role.Create": "Rolle erstellen",
        "Role.Delete": "Rolle löschen",
        "Role.Read": "Rolle lesen",
        "Role.Update": "Rollenaktualisierung",
        "Task.Create": "Aufgaben erstellen",
        "Task.Read": "Aufgabe lesen",
        "Task.Retry": "Wiederholung von Aufgaben",
        "Task.Update": "Aufgabenaktualisierung",
        "TaskGroup.Read": "Aufgabengruppe lesen",
        "TctIntegration.Access": "TCT-Integration",
        "Token.Create": "Token erstellen",
        "Token.Delete": "Token löschen",
        "Token.Read": "Token lesen",
        "User.Create": "",
        "User.Delete": "Benutzer löschen",
        "User.Read": "Benutzer lesen",
        "User.Update": "Benutzeraktualisierung",
        "--- END-OF-PERMISSIONS ---": "",
        "1-wire authorization list": "1-Wire-Autorisierungsliste",
        "1_wire_authorization_list": "1-Wire-Autorisierungsliste",
        "Active": "Aktiv",
        "adas_firmware": "ADAS-Firmware",
        "apx_firmware": "APX-Firmware",
        "assign can package": "CAN-Paket zuweisen",
        "assigned package": "Zugewiesenes Paket",
        "automatic": "Automatisch",
        "banner management": "",
        "batches": "Aufgabengruppen",
        "black_box": "Black Box",
        "ble_dtb": "BLE DTB",
        "ble_fw": "BLE-Firmware",
        "blue_nrg": "BlueNRG-Firmware",
        "BluetoothAuthorizationList": "",
        "bluetooth authorization list": "Bluetooth-Autorisierungsliste",
        "bluetooth_authorization_list": "Bluetooth-Autorisierungsliste",
        "bluetooth password": "",
        "boolean filtered value name": {
            "task_support": {
                "false": "Inkompatibel",
                "true": "Kompatibel"
            },
            "web_editor_support": {
                "false": "TCT web nicht unterstützt",
                "true": "TCT web-Unterstützung"
            }
        },
        "can": "CAN",
        "can adapter name": "CAN-Adaptername",
        "can bootstring": "Bootstring",
        "can configuration": "OEM-Konfiguration",
        "can_debug_log": "CAN-Debug-Protokoll",
        "can oem file package": "OEM-Dateipaket",
        "can oem file vehicle": "OEM-Datei-Vehikel",
        "can package": "OEM-Paket",
        "can program number": "CAN-Programmnummer",
        "can revision": "CAN-Überarbeitung",
        "can software date": "CAN-Software-Datum",
        "can type": "CAN-Typ",
        "Cancelled": "Abgebrochen",
        "cancel task": "Aufgabe abbrechen",
        "can_chip_firmware": "FM CAN Chip-Firmware",
        "carrier_advance_firmware": "Carrier Advance-Firmware",
        "carrier_advance_settings": "Carrier Advance Einstellungen",
        "carrier_apx_firmware": "Carrier APX-Firmware",
        "carrier_apx_settings": "Carrier APX-Einstellungen",
        "carrier_extractions": "Carrier extractions",
        "carrier_logger_files": "Carrier Temperature Logger-Dateien",
        "certificate": "Zertifikat",
        "click for more details": "Klicken Sie hier für weitere Details",
        "client ip": "Client-IP",
        "clone model": "Gerätemodell klonen",
        "collapse menu": "Menü ausblenden",
        "companies": "Unternehmen",
        "company": "Unternehmen",
        "company level": "Auf Unternehmensebene",
        "company type": "Unternehmenstyp",
        "company name": "Firmenname",
        "Completed": "Abgeschlossen",
        "Completed with errors": "Mit Fehlern abgeschlossen",
        "configuration": "Konfiguration",
        "configuration_36": "Konfiguration (FM36)",
        "configuration_64": "Konfiguration (FMB64)",
        "crash_dump": "Crash-Dump-Protokoll",
        "created at": "Erstellt am",
        "created by": "Erstellt von",
        "custom": "Kundenspezifisch",
        "custom resource limits": "Benutzerdefinierte Ressourcenbeschränkungen",
        "dashboard": "Dashboard",
        "delete desktop license": "Desktop-Lizenz löschen",
        "delete offline license": "Offline-Lizenz löschen",
        "desktopLicenses": "Desktop-Lizenzen",
        "device_export_file_csv": "Geräteexportdatei (.csv)",
        "device_export_file_xlsx": "Geräteexportdatei (.xlsx)",
        "deviceModels": "Modelle",
        "deviceModelTaskCompatibilities": "Kompatibilitäten",
        "device_transfer_report": "Geräteübertragungsbericht",
        "device group": "Gruppe",
        "DeviceImportFile": "Geräteimportdatei",
        "devices": "Geräte",
        "download file": "Datei herunterladen",
        "download offline license": "Offline-Lizenz herunterladen",
        "dsm_firmware": "DSM-Firmware",
        "dtb": "DTB",
        "edit compatibility": "Gerätekompatibilität bearbeiten",
        "edit model": "Gerätemodell bearbeiten",
        "edit company": "Unternehmen bearbeiten",
        "edit desktop license": "Desktop-Lizenz bearbeiten",
        "edit device": "Gerät bearbeiten",
        "edit file": "Datei bearbeiten",
        "edit group": "Gruppe bearbeiten",
        "edit in tct web": "Bearbeiten in TCT web",
        "edit in tct web disabled": "Die Bearbeitung in TCT web ist nur für Premium-Unternehmen verfügbar.",
        "edit product code": "Produktcode bearbeiten",
        "edit role": "Rolle bearbeiten",
        "edit smart group": "Intelligente Gruppe bearbeiten",
        "edit user": "Benutzer bearbeiten",
        "Empty": "Leer",
        "enter here": "Hier eintreten",
        "exception_info": "Ausnahmeinformationen",
        "Executing": "Ausführung",
        "expand menu": "Menü erweitern",
        "Expired": "Abgelaufen",
        "Factory": "",
        "Failed": "Fehlgeschlagen",
        "file": "Datei",
        "file data": "Dateidaten",
        "files": "Dateien",
        "file deleted": "Datei wurde gelöscht",
        "firmware": "Firmware",
        "firmware_36": "Firmware (FM36)",
        "firmware_64": "Firmware (FMB64)",
        "Fmx": "FMx",
        "Fota": "",
        "Ft": "FT",
        "fw_bundle": "Firmware-Paket",
        "fw_bundle_ble": "Bundle – BLE-Firmware",
        "fw_bundle_ble_dtb": "Bundle – BLE DTB",
        "fw_bundle_can": "Bundle – CAN-Firmware",
        "fw_bundle_can_dtb": "Bundle – CAN DTB",
        "fw_bundle_dtb": "Bundle – Haupt-DTB",
        "fw_bundle_mainfw": "Bundle – Haupt-Firmware",
        "generic": "",
        "global_configuration": "Globale Konfiguration",
        "global_firmware": "Globale Firmware",
        "gnssm_download_assistant": "GNSS-M Download Assistant",
        "gnssm_firmware": "GNSS-M-Firmware",
        "group": "Gruppe",
        "groups": "Gerätegruppen",
        "hardware key": "Hardware-Schlüssel",
        "id": "ID",
        "id_collection_file": "ID-Erfassungsdatei",
        "imei restriction": "IMEI-Beschränkung",
        "Inactive": "Inaktiv",
        "Invalid": "Ungültig",
        "invalid model": "Ungültiges Modell",
        "invalid model_name": "Ungültiges Modell",
        "InvitationExpired": "Abgelaufene Einladung",
        "InvitationPending": "Einladung ausstehend",
        "Legacy": "Legacy",
        "legacy model": "Altes Modell",
        "legacy model_platform": "Legacy-Plattform",
        "legacy platform": "Legacy-Plattform",
        "license has expired": "Die Lizenz ist abgelaufen",
        "loading": "Laden",
        "log": "Protokoll",
        "MainConfiguration": "",
        "main configuration": "",
        "manual": "Manuell",
        "ManualGeofenceList": "",
        "manual geofence list": "Liste manueller Geofence-Szenarien",
        "manual_geofence_list": "Liste manueller Geofence-Szenarien",
        "meig_modem_firmware": "MeiG-Modem-Firmware",
        "menu": "Menü",
        "modem version": "Modem-Version",
        "netprisma_modem_firmware": "NETPRISMA-Modem-Firmware",
        "nmea_log": "NMEA-Protokoll",
        "no": "Nein",
        "no results": "Keine ersten Ergebnisse gefunden",
        "no results description": "Sobald {{name}} auf FOTA WEB hochgeladen sind, können Sie die Daten hier einsehen",
        "not assigned": "Nicht zugewiesen",
        "not assigned configuration_file_id": "Konfiguration nicht zugewiesen",
        "not assigned current_configuration": "Konfiguration nicht zugewiesen",
        "not assigned current_firmware": "Firmware nicht zugewiesen",
        "not assigned firmware_file_id": "Firmware nicht zugewiesen",
        "not assigned group_id": "Gruppe nicht zugewiesen",
        "not assigned model": "Modell nicht zugewiesen",
        "not assigned spec_id": "Spec ID nicht zugewiesen",
        "not assigned task_type": "Aufgabentyp nicht zugewiesen",
        "obd_chip_firmware": "FM OBD Chip-Firmware",
        "obd chip firmware version": "OBD-Chip-Firmware-Version",
        "Offline": "Offline",
        "offline licenses": "Offline-Lizenzen",
        "Online": "Online",
        "OneWireAuthorizationList": "",
        "open in tct": "",
        "or": "oder",
        "other": "Sonstiges",
        "Pending": "Ausstehend",
        "Pending approval": "Warten auf Genehmigung",
        "permission disabled": "Deaktiviert",
        "permission enabled": "Aktiviert",
        "productCodes": "Produktcodes",
        "psub": "Abonnementdatei",
        "quectel_fw": "Quectel-Modem-Firmware (quectel_fw)",
        "quectel_modem_firmware": "Quectel-Modem-Firmware",
        "resend invite": "Einladung erneut senden",
        "restricted": "Eingeschränkt",
        "retry": "Wiederholen",
        "roles": "Rollen und Berechtigungen",
        "Running": "Ausführung",
        "RxAutoscan": "Automatisches Scannen von CAN-Dateien",
        "RxBlackBox": "Blackbox empfangen",
        "RxBluetoothAuthorizationList": "Empfangen der Bluetooth-Autorisierungsliste",
        "RxCanDebugLog": "CAN-Debug-Protokoll empfangen",
        "RxCarrierExtractions": "Herunterladen von Carrier extractions",
        "RxCarrierLoggerFiles": "Dateien des Carrier-Temperaturloggers herunterladen",
        "RxConfiguration": "Konfiguration empfangen",
        "RxCrashDump": "Crash-Dump-Protokoll empfangen",
        "RxExceptionInfo": "Ausnahmeinformationen empfangen",
        "RxLog": "Interne Protokolle empfangen",
        "RxManualGeofenceList": "Manuelle Geofence-Szenario-Liste erhalten",
        "RxNmeaLog": "NMEA-Protokoll empfangen",
        "RxOneWireAuthorizationList": "1-Wire-Autorisierungsliste erhalten",
        "RxWdLog": "Watchdog-Protokoll (WD) empfangen",
        "select company": "Unternehmen auswählen",
        "SetBindSim": "Gerät mit aktuellen SIM-Karte(n) verbinden",
        "SetBluetoothPassword": "",
        "SetDisableFeature": "Funktion deaktivieren",
        "SetEnableFeature": "Funktion aktivieren",
        "SetForceLockSim": "SIM-Karte zwangsweise sperren",
        "SetUnbindSim": "Gerät mit SIM-Karte(n) trennen",
        "simcom_modem_firmware": "",
        "SmsGprs": "",
        "status": "Status",
        "task details": "Aufgabendetails",
        "task groups": "Aufgabengruppen",
        "tasks": "Aufgabengruppen",
        "tasksCompatibility": "Aufgabenkompatibilität",
        "task type": "Aufgabentyp",
        "Tct": "",
        "time zone": "Zeitzone",
        "total": "Gesamt",
        "tutorials": "Tutorials",
        "TxAdasFirmware": "ADAS-Firmware hochladen",
        "TxAgpsMt3333": "AGPSM-Datei übertragen",
        "TxAgpsQuectelL89": "AGPSQ-Datei übertragen",
        "TxAutoscanCanConfiguration": "Automatisches Scannen von OEM-Dateien hochladen",
        "TxBleFirmware": "BLE-Firmware hochladen",
        "TxBlueNrgFirmware": "BlueNrg-Firmware hochladen",
        "TxBluetoothAuthorizationList": "Bluetooth-Autorisierungsliste hochladen",
        "TxBundleBle": "BLE-Firmware hochladen",
        "TxBundleBleDtb": "BLE DTB hochladen",
        "TxBundleCan": "CAN-Firmware hochladen",
        "TxBundleCanDtb": "CAN-DTB hochladen",
        "TxBundleDtb": "Haupt-DTB hochladen",
        "TxBundleFirmware": "Hauptfirmware hochladen",
        "TxCanAdapterModeChange": "Ändern des Modus des externen CAN-Adapters",
        "TxCanAdapterModeChangeInternal": "Ändern des internen CAN-Adaptermodus",
        "TxCanAdapterUpdate": "Firmware für CAN-Adapter hochladen",
        "TxCanAdapterUpdateInternal": "Interner CAN-Adapter aktualisieren",
        "TxCanChipFirmware": "FMXY50 CAN-Chip-Firmware hochladen",
        "TxCanConfiguration": "OEM-Datei hochladen",
        "TxCarrierAdvanceFirmware": "Update der Carrier Advance-Firmware",
        "TxCarrierAdvanceSettings": "Aktualisieren Sie die erweiterten Einstellungen von Carrier Advance",
        "TxCarrierApxFirmware": "Aktualisierung der Carrier APX-Firmware",
        "TxCarrierApxSettings": "Aktualisieren Sie die Carrier APX-Einstellungen",
        "TxConfiguration": "Konfiguration hochladen",
        "TxDsmFirmware": "DSM-Firmware hochladen",
        "TxDtb": "DTB hochladen",
        "TxFirmware": "Firmware hochladen",
        "TxFirmwareBundle": "Firmware-Bundle-Container hochladen",
        "TxFirmwareBundleParts": "Firmware-Paket hochladen",
        "TxFotaCertificate": "FOTA-Zertifikat aktualisieren",
        "TxGenericFile": "",
        "TxGNSSMDownloadAssistant": "GNSS-M hochladen Download-Assistent",
        "TxGNSSMFirmware": "GNSS-M-Firmware hochladen",
        "TxManualGeofenceList": "Manuelle Geofence-Szenario-Liste hochladen",
        "TxMeigModemDeltaFirmware": "MeiG Delta Modem-Firmware hochladen",
        "TxNetprismaModemDeltaFirmware": "NETPRISMA Delta Modem-Firmware hochladen",
        "TxObdChipFirmware": "OBD-Chip aktualisieren",
        "TxObdConfig": "OBD-Konfigurationsdatei übertragen",
        "TxOneWireAuthorizationList": "1-Wire-Autorisierungsliste hochladen",
        "TxPSub": "Abonnementdatei übertragen",
        "TxQuectelModemDeltaFirmware": "Quectel Delta Modem-Firmware hochladen",
        "TxSimcomModemDeltaFirmware": "",
        "TxUserCertificate": "TLS-Zertifikat des Benutzers hochladen",
        "users": "Benutzer",
        "Unknown": "Unbekannt",
        "unknown": "Unbekannt",
        "unknown model_platform": "Unbekannte Plattform",
        "unknown origin": "",
        "unknown platform": "Unbekannte Plattform",
        "unrestricted": "Uneingeschränkt",
        "Verifying": "Überprüfen",
        "vin": "VIN",
        "vip status": "VIP-Status",
        "wd_log": "WD-Protokoll",
        "yes": "Ja"
    },
    "Maintenance": {
        "title": "Bitte warten Sie! Wir führen derzeit Wartungsarbeiten durch."
    },
    "Notifications": {
        "description": {
            "{{BackgroundActionType}} failed due to server error": "{{BackgroundActionType}} ist aufgrund eines Serverfehlers fehlgeschlagen.",
            "Cancel tasks action failed. Invalid request scope. Resources must belong to single root.": "Sie haben keine Berechtigung, alle ausgewählten Aufgaben zu stornieren. Einige Aufgaben sind mit Ressourcen verschiedener Unternehmen verbunden.",
            "Cancel tasks action failed. No resources found.": "Es wurden keine Aufgaben gefunden, die Ihrer Auswahl entsprechen. Bitte überprüfen Sie Ihre Aufgabenauswahl und versuchen Sie es erneut.",
            "Company \"{{SourceCompanyName}}\" ({{SourceCompanyId}}) merged into \"{{TargetCompanyName}}\" (<TargetCompanyId>).": "Das Unternehmen „{{SourceCompanyName}}“ ({{SourceCompanyId}}) fusionierte mit „{{TargetCompanyName}}“ ({{TargetCompanyId}}).",
            "Company merge failed. Companies '{{SourceCompanyId}}' and '{{TargetCompanyId}}' cannot be merged due to incompatible settings or permissions.": "Die Unternehmensfusion ist fehlgeschlagen. Die Unternehmen „{{SourceCompanyId}}“ und „{{TargetCompanyId}}“ können aufgrund inkompatibler Einstellungen oder Berechtigungen nicht fusioniert werden.",
            "Create device group tasks action failed. No resources found.": "Es ist nicht gelungen, Aufgaben für die Smart Group zu erstellen. Bitte versuchen Sie, die Datei neu zuzuweisen.",
            "{{CreatedTaskCount}} task(s) created for device group ID:{{GroupId}} devices.": "{{CreatedTaskCount}} Aufgabe(n) für Gerätegruppe ID:{{GroupId}} Geräte erstellt.",
            "Create tasks action failed. Invalid request scope. Resources must belong to single root.": "Sie haben keine Berechtigung, Aufgaben für alle ausgewählten Geräte zu erstellen. Einige Geräte gehören zu anderen Unternehmen.",
            "Create tasks action failed. No resources found.": "Es wurden keine Geräte gefunden, die Ihrer Auswahl entsprechen. Bitte überprüfen Sie Ihre Geräteauswahl und versuchen Sie es erneut.",
            "Create tasks action failed. No resources processed.": "Die ausgewählten Geräte konnten nicht verarbeitet werden. Bitte versuchen Sie erneut, eine Aufgabengruppe zu erstellen.",
            "Delete companies action failed. Invalid request scope. Resources must belong to single root.": "Sie haben keine Berechtigung, alle ausgewählten Unternehmen zu löschen. Einige Unternehmen unterstehen nicht Ihrer direkten Verwaltung.",
            "Delete companies action failed. No resources found.": "Es wurden keine Unternehmen gefunden, die Ihrer Auswahl entsprechen. Bitte überprüfen Sie Ihre Unternehmensauswahl und versuchen Sie es erneut.",
            "Delete files action failed. Invalid request scope. Resources must belong to single root.": "Sie haben keine Berechtigung, alle ausgewählten Dateien zu löschen. Einige Dateien sind mit Ressourcen verschiedener Unternehmen verknüpft.",
            "Delete files action failed. No resources found.": "Es wurden keine Dateien gefunden, die Ihrer Auswahl entsprechen. Bitte überprüfen Sie Ihre Dateiauswahl und versuchen Sie es erneut.",
            "Delete groups action failed. Invalid request scope. Resources must belong to single root.": "Sie haben keine Berechtigung, alle ausgewählten Gerätegruppen zu löschen. Einige Gerätegruppen enthalten Ressourcen von verschiedenen Unternehmen.",
            "Delete groups action failed. No resources found.": "Es wurden keine Gerätegruppen gefunden, die Ihrer Auswahl entsprechen. Bitte überprüfen Sie Ihre Auswahl der Gerätegruppen und versuchen Sie es erneut.",
            "Delete product codes action failed. No resources found.": "Es wurden keine Produktcodes gefunden, die Ihrer Auswahl entsprechen. Bitte überprüfen Sie Ihre Produktauswahl und versuchen Sie es erneut.",
            "Delete users action failed. Invalid request scope. Resources must belong to single root.": "Sie haben keine Berechtigung, alle ausgewählten Benutzer zu löschen. Einige Benutzer gehören zu verschiedenen Unternehmen.",
            "Delete users action failed. No resources found.": "Es wurden keine Benutzer gefunden, die Ihrer Auswahl entsprechen. Bitte überprüfen Sie Ihre Benutzerauswahl und versuchen Sie es erneut.",
            "Device group ID:{{GroupId}} move failed. Target company ID:{{TargetCompanyId}} cannot be found.": "",
            "Device group ID:{{GroupId}} successfully moved to company ID:{{TargetCompanyId}}.": "",
            "{{DevicesCount}} device(s) exported to \"{{Filename}}\".": "{{DevicesCount}} Gerät(e) exportiert nach „{{Filename}}“.",
            "{{DevicesCount}} device(s) imported.": "{{DevicesCount}} Gerät(e) importiert.",
            "{{DevicesProcessedCount}} device(s) processed, {{TasksCreatedCount}} task(s) created.": "{{DevicesProcessedCount}} Gerät(e) verarbeitet, {{TasksCreatedCount}} Aufgabe(n) erstellt.",
            "Export devices action failed. No resources found.": "Es wurden keine Geräte gefunden, die Ihrer Auswahl entsprechen. Bitte überprüfen Sie Ihre Geräteauswahl und versuchen Sie es erneut.",
            "{{FailedTaskCount}} task(s) returned to pending in task group {{BatchId}}.": "{{FailedTaskCount}} Aufgabe(n) wurde(n) in der Aufgabengruppe {{BatchId}} wieder in den Status „Ausstehend” versetzt.",
            "Invalid request scope. Resources must belong to single root.": "Ungültiger Anforderungsbereich. Ressourcen müssen zu einem einzigen Stammverzeichnis gehören.",
            "Move device group action failed. No resources found.": "",
            "{{ProcessedCount}} companies deleted.": "{{ProcessedCount}} Unternehmen gelöscht.",
            "{{ProcessedCount}} device group(s) deleted.": "{{ProcessedCount}} Gerätegruppen gelöscht.",
            "{{ProcessedCount}} device attribute(s) updated.": "{{ProcessedCount}} Geräteattribute aktualisiert.",
            "{{ProcessedCount}} device model(s) deleted.": "{{ProcessedCount}} Gerätemodell(e) gelöscht.",
            "{{ProcessedCount}} device(s) updated.": "{{ProcessedCount}} Gerät(e) aktualisiert.",
            "{{ProcessedCount}} file(s) deleted.": "{{ProcessedCount}} Datei(en) gelöscht.",
            "{{ProcessedCount}} product code(s) deleted.": "{{ProcessedCount}} Produktcodes gelöscht.",
            "{{ProcessedCount}} task(s) canceled.": "{{ProcessedCount}} Aufgabe(n) abgebrochen.",
            "{{ProcessedCount}} task(s) updated.": "{{ProcessedCount}} Aufgabe(n) aktualisiert.",
            "{{ProcessedCount}} user(s) deleted.": "{{ProcessedCount}} Benutzer gelöscht.",
            "Retry tasks action failed. No resources found.": "Es wurden keine Aufgaben gefunden, die Ihrer Auswahl entsprechen. Bitte überprüfen Sie Ihre Aufgabenauswahl und versuchen Sie es erneut.",
            "Transfer devices action failed. Invalid request scope. Resources must belong to single root.": "Sie haben keine Berechtigung, alle ausgewählten Geräte zu übertragen. Einige Geräte gehören zu anderen Unternehmen.",
            "Transfer devices action failed. No resources found.": "Es wurden keine Geräte gefunden, die Ihrer Auswahl entsprechen. Bitte überprüfen Sie Ihre Geräteauswahl und versuchen Sie es erneut.",
            "Transfer devices action failed. No resources processed.": "Die ausgewählten Geräte konnten nicht verarbeitet werden. Bitte versuchen Sie erneut, die Geräte zu übertragen.",
            "{{TransferredDevicesCount}} of {{TotalDevicesToTransfer}} device(s) transferred.": "{{TransferredDevicesCount}} von {{TotalDevicesToTransfer}} Geräten wurden übertragen.",
            "Update devices action failed. Invalid request scope. Resources must belong to single root.": "Sie haben keine Berechtigung, alle ausgewählten Geräte zu aktualisieren. Einige Geräte gehören zu anderen Unternehmen.",
            "Update devices action failed. No resources found.": "Es wurden keine Geräte gefunden, die Ihrer Auswahl entsprechen. Bitte überprüfen Sie Ihre Geräteauswahl und versuchen Sie es erneut.",
            "Update devices attributes action failed. Invalid request scope. Resources must belong to single root.": "Sie haben keine Berechtigung, die Attribute für alle ausgewählten Geräte zu aktualisieren. Einige Geräte gehören zu anderen Unternehmen.",
            "Update devices attributes action failed. No resources found.": "Es wurden keine Geräte gefunden, die Ihrer Auswahl entsprechen. Bitte überprüfen Sie Ihre Geräteauswahl und versuchen Sie es erneut.",
            "Update tasks action failed. Invalid request scope. Resources must belong to single root.": "Sie haben keine Berechtigung, alle ausgewählten Aufgaben zu aktualisieren. Einige Aufgaben sind mit Ressourcen verschiedener Unternehmen verknüpft.",
            "Update tasks action failed. No resources found.": "Es wurden keine Aufgaben gefunden, die Ihrer Auswahl entsprechen. Bitte überprüfen Sie Ihre Aufgabenauswahl und versuchen Sie es erneut.",
            "User access is scheduled to expire at {{ExpiresAt}} UTC. To maintain uninterrupted service, please contact your company's administrators immediately to request an extension.": ""
        },
        "no notifications": "Keine Benachrichtigungen",
        "notifications": "Benachrichtigungen",
        "notifications will be listed": "Alle neuen Benachrichtigungen werden hier aufgelistet",
        "remove notification": "Benachrichtigung entfernen",
        "see previous notifications": "Siehe vorherige Benachrichtigungen",
        "timestamps": {
            "days ago": "Vor {{days}} Tagen",
            "hours ago": "Vor {{hours}} Stunden",
            "minutes ago": "Vor {{minutes}} Minuten",
            "moments ago": "Vor wenigen Augenblicken"
        },
        "title": {
            "BackgroundActionFailed": "Aktion fehlgeschlagen",
            "CompaniesSuccessfullyDeleted": "Unternehmen erfolgreich gelöscht",
            "CompanyBulkDeleteFailed": "Beim Löschen von Unternehmen ist ein Fehler aufgetreten",
            "CompanyLevelChanged": "Unternehmensebene geändert",
            "CompanyLevelDowngradeReminder": "Bevorstehende Herabstufung auf Unternehmensebene",
            "CompanyMergeFailed": "Beim Zusammenführen von Unternehmen ist ein Fehler aufgetreten",
            "CompanySuccessfullyMerged": "Unternehmen erfolgreich fusioniert",
            "DeviceAttributesSuccessfullyUpdated": "Geräteattribute erfolgreich aktualisiert",
            "DeviceBulkAttributeUpdateFailed": "Beim Aktualisieren der Geräteattribute ist ein Fehler aufgetreten",
            "DeviceBulkUpdateFailed": "Bei der Aktualisierung der Geräte ist ein Fehler aufgetreten",
            "DeviceExportFailed": "Beim Exportieren von Geräten ist ein Fehler aufgetreten",
            "DeviceGroupMoveFailed": "",
            "DeviceGroupsSuccessfullyDeleted": "Gerätegruppen erfolgreich gelöscht",
            "DeviceGroupSuccessfullyMoved": "",
            "DeviceGroupTasksCreateFailed": "Beim Erstellen von Smart Group-Aufgaben ist ein Fehler aufgetreten",
            "DeviceGroupTasksSuccessfullyCreated": "Smart Group-Aufgaben erfolgreich erstellt",
            "DeviceModelBulkDeleteFailed": "Beim Löschen von Gerätemodellen ist ein Fehler aufgetreten",
            "DeviceModelsSuccessfullyDeleted": "Gerätemodelle erfolgreich gelöscht",
            "DevicesSuccessfullyTransferred": "Geräte erfolgreich übertragen",
            "DevicesSuccessfullyUpdated": "Geräte erfolgreich aktualisiert",
            "DeviceTransferFailed": "Bei der Übertragung von Geräten ist ein Fehler aufgetreten",
            "ExportFailed": "Ressourcenexport fehlgeschlagen",
            "ExportSucceeded": "Geräte erfolgreich exportiert",
            "FailedTasksRetryFailed": "Beim erneuten Ausführen der Aufgaben ist ein Fehler aufgetreten",
            "FailedTasksSuccessfullyRetried": "Aufgaben erfolgreich wiederholt",
            "FileBulkDeleteFailed": "Beim Löschen von Dateien ist ein Fehler aufgetreten",
            "FilesSuccessfullyDeleted": "Dateien erfolgreich gelöscht",
            "GroupBulkDeleteFailed": "Beim Löschen von Gerätegruppen ist ein Fehler aufgetreten",
            "ImportFailed": "Import der Ressource fehlgeschlagen",
            "ImportSucceeded": "Geräte erfolgreich importiert",
            "ProductCodeBulkDeleteFailed": "Beim Löschen von Produktcodes ist ein Fehler aufgetreten",
            "ProductCodesSuccessfullyDeleted": "Produktcodes erfolgreich gelöscht",
            "ResourceUpdateFailed": "Ressourcenaktualisierung fehlgeschlagen",
            "ResourceUpdateSucceeded": "Ressourcenaktualisierung erfolgreich",
            "RoleBulkDeleteFailed": "Beim Löschen von Rollen ist ein Fehler aufgetreten",
            "RolesSuccessfullyDeleted": "Rollen erfolgreich gelöscht",
            "TaskBulkCancelFailed": "Beim Abbrechen von Aufgaben ist ein Fehler aufgetreten",
            "TaskBulkCreateFailed": "Beim Erstellen einer Aufgabengruppe ist ein Fehler aufgetreten",
            "TaskBulkUpdateFailed": "Beim Aktualisieren der Aufgaben ist ein Fehler aufgetreten",
            "TaskGroupSuccessfullyCreated": "Aufgabengruppe erfolgreich erstellt",
            "TasksPropagationFailed": "Aufgabe zur Weitergabe von Aufgaben fehlgeschlagen",
            "TasksPropagationSucceeded": "Aufgabenübertragung erfolgreich abgeschlossen",
            "TasksPropagationWarning": "Die Aufgabenübertragung wurde mit Warnungen beendet",
            "TasksSuccessfullyCanceled": "Aufgaben erfolgreich abgebrochen",
            "TasksSuccessfullyUpdated": "Aufgaben erfolgreich aktualisiert",
            "UserBulkDeleteFailed": "Beim Löschen von Benutzern ist ein Fehler aufgetreten",
            "UserExpireReminder": "",
            "UsersSuccessfullyDeleted": "Benutzer erfolgreich gelöscht"
        }
    },
    "Permission actions": {
        "Access": "TCT-Integration",
        "Create": "Erstellen",
        "Delete": "Löschen",
        "Download": "Herunterladen",
        "Export": "Exportieren",
        "Merge": "Zusammenführen",
        "Read": "Lesen",
        "Retry": "Wiederholen",
        "SecretsRead": "",
        "TctWebAccess": "TCT web",
        "Transfer": "Übertragung",
        "Unlock": "Entsperren",
        "Update": "Aktualisieren"
    },
    "Permission groups": {
        "company": "Unternehmen",
        "device": "Geräte",
        "device group": "Gerätegruppen",
        "file": "Dateien",
        "role": "Rollen",
        "task": "Aufgaben",
        "task group": "Aufgabengruppen",
        "token": "Tokens",
        "user": "Benutzer"
    },
    "Restrictions": {
        "feature_settings": {
            "api_token_support": {
                "input option": "Diese Option ist für Benutzer mit Basis-Unternehmenslevel deaktiviert.",
                "token list": "API-Integrationstoken sind für Benutzer mit Basis-Unternehmenslevel deaktiviert."
            },
            "custom_role_support": {
                "create role": "Diese Funktion kann nur von Benutzern mit Premium-Unternehmensstatus genutzt werden.",
                "edit role": "Diese Funktion kann nur von Benutzern mit Premium-Unternehmensstatus genutzt werden. Zuvor erstellte benutzerdefinierte Rollen können gelöscht werden.",
                "edit user": "Diese Funktion kann nur von Benutzern mit Premium-Unternehmensstatus genutzt werden. Zuvor zugewiesene benutzerdefinierte Rollen können entfernt werden."
            },
            "task_schedule_support": {
                "table head": "Diese Funktion kann nur von Benutzern mit Standard- und Premium-Unternehmenslevels genutzt werden. Zuvor hinzugefügte Aufgaben mit Zeitplänen werden weiterhin ausgeführt."
            }
        },
        "general message": "Diese Funktion kann nur von Benutzern mit Standard- und Premium-Unternehmenslevels genutzt werden.",
        "resource_limit_settings": {
            "tasks_per_group": "Sie können nicht mehr als {{limitCount}} Geräte gleichzeitig für Aufgaben auswählen."
        }
    },
    "Search": {
        "code": "Code",
        "description": "Beschreibung",
        "email": "E-Mail",
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "model": "Modell",
        "name": "Name",
        "product code": "Produktcode",
        "role name": "Rollenname",
        "serial": "Seriennummer.",
        "search by": "Suche nach",
        "search company name": "Firmenname suchen"
    },
    "Security": {
        "2FA": {
            "disable": {
                "confirmation": {
                    "description": "Sie sind dabei, Ihre Zwei-Faktor-Authentifizierung zu deaktivieren. Dies könnte Ihr FOTA WEB-Konto unsicher machen. Möchten Sie wirklich fortfahren?",
                    "title": "Sind Sie sicher?"
                },
                "send email code": {
                    "enter code": "Aus Sicherheitsgründen geben Sie bitte den Code ein, um die E-Mail zu verifizieren."
                },
                "send otp code": {
                    "description": "Ein 6-stelliger Code wurde an Ihre Authentifizierungs-App gesendet. Aus Sicherheitsgründen geben Sie bitte den generierten Code in das untenstehende Feld ein.",
                    "no access": {
                        "authenticator": "Wenn Sie keinen Zugriff mehr auf die mit diesem Konto verknüpfte Authentifizierungs-App haben, ist eine Passwortänderung erforderlich, um die Zwei-Faktor-Authentifizierung zu deaktivieren.",
                        "email": "Wenn Sie keinen Zugriff mehr auf die mit diesem Konto verknüpfte E-Mail-Adresse haben, ist eine Passwortänderung erforderlich, um die Multi-Faktor-Authentifizierung zu deaktivieren."
                    }
                },
                "title": "Zwei-Faktor-Authentifizierung deaktivieren"
            },
            "get email code": {
                "description": "Verwenden Sie diesen Code auf dem nächsten Bildschirm, um Ihr Konto zu verifizieren.",
                "description modal": "Verwenden Sie diesen Code, um Ihr Konto zu verifizieren.",
                "title": "Durch Klicken auf „Code senden“ wird ein eindeutiger Code an <1>{{email}}</1> gesendet."
            },
            "get secret code": {
                "description": "Sie benötigen eine Authentifizierungs-App für Mobilgeräte, um diesen Vorgang abzuschließen, beispielsweise eine der folgenden:"
            },
            "select authentication type": {
                "authentication app description": "Beziehen Sie einen eindeutigen Code aus einer App wie Microsoft Authenticator oder Google Authenticator.",
                "description": "Um die Sicherheit Ihres Kontos und Ihrer Kundendaten zu gewährleisten, richten Sie bitte mithilfe einer der folgenden Optionen eine Zwei-Faktor-Authentifizierung ein.",
                "description modal": "Wählen Sie Ihre bevorzugte Authentifizierungsmethode aus.",
                "email": "E-Mail",
                "email description": "Wir senden Ihnen jedes Mal, wenn Sie sich anmelden möchten, einen einmaligen Code per E-Mail zu.",
                "recommended": "Empfohlen",
                "title": "Die Zwei-Faktor-Authentifizierung (2FA) ist für alle FOTA WEB-Benutzer obligatorisch.",
                "title modal": "Authentifizierungsmethode auswählen"
            },
            "send email code": {
                "description": "Bitte geben Sie den Code in das untenstehende Feld ein und klicken Sie auf „Überprüfen“, um fortzufahren.",
                "enter code": "Bitte geben Sie den Code ein, um die E-Mail zu bestätigen.",
                "title": "Ein eindeutiger Code wurde an <1>{{email}}</1> gesendet.",
                "verification code": "Verifizierungscode"
            },
            "send otp code": {
                "click to scan code": "Klicken Sie hier, um stattdessen einen QR-Code zu scannen",
                "click to type code": "Klicken Sie hier, um den Code manuell einzugeben",
                "incorrect code": "Falscher Code",
                "scan QR code": "Scannen Sie den QR-Code in Ihre App",
                "six digit code": "6-stelliger Code, der von Ihrer App generiert wird",
                "title": "Sie benötigen eine Authentifizierungs-App für Mobilgeräte, um diesen Vorgang abzuschließen, z. B. <1>Microsoft Authenticator</1> oder <2>Google Authenticator</2>.",
                "type text code": "Geben Sie den Textcode in Ihre App ein"
            },
            "settings": {
                "description": "Die Zwei-Faktor-Authentifizierung ist eine zusätzliche Sicherheitsstufe, die Ihre Identität anhand von etwas, das Sie wissen (Passwort), und etwas, das Sie haben (Telefon, Sicherheitsschlüssel, E-Mail), überprüft.",
                "disabled": "Deaktiviert",
                "enabled": "Aktiviert",
                "title": "Zwei-Faktor-Authentifizierung"
            },
            "success message": {
                "alert": "Zwei-Faktor-Authentifizierung erfolgreich aktiviert.",
                "description": "Bei jeder Anmeldung mit Ihrer E-Mail-Adresse und Ihrem Passwort werden Sie zur Eingabe eines Authentifizierungscodes aufgefordert.",
                "title": "Sie haben die Zwei-Faktor-Authentifizierung erfolgreich aktiviert.",
                "title modal": "Zwei-Faktor-Authentifizierung aktiviert!"
            },
            "title": {
                "authentication app": "Authentifizierungs-App",
                "authentication email": "Authentifizierungs-E-Mail",
                "is enabled": "Zwei-Faktor-Authentifizierung aktiviert.",
                "protect your account": "Schützen Sie Ihr FOTA WEB-Konto"
            }
        },
        "delete account": {
            "confirmation": {
                "account": "",
                "banner": "",
                "cancel info": "",
                "more info": "",
                "description": "",
                "title": "",
                "verification code description": {
                    "authenticator": "",
                    "email": ""
                }
            },
            "settings": {
                "description": "",
                "title": ""
            }
        },
        "password": {
            "change password": "Passwort ändern",
            "enter current password": "Aktuelles Passwort eingeben",
            "enter new password": "Neues Passwort eingeben",
            "hide password": "Passwort ausblenden",
            "repeat new password": "Neues Passwort wiederholen",
            "rules": {
                "lowercase letter": "Mindestens ein Kleinbuchstabe (a–z)",
                "minimum characters": "Mindestens 12 Zeichen",
                "new and current passwords must not match": "Neue und aktuelle Passwörter dürfen nicht übereinstimmen",
                "new passwords must match": "Neue Passwörter müssen übereinstimmen",
                "number": "Mindestens eine Nummer",
                "passwords must match": "Passwörter müssen übereinstimmen",
                "special symbol": "Mindestens ein Sonderzeichen (!@#$%^&*()-_=+)",
                "uppercase letter": "Mindestens ein Großbuchstabe (A-Z)"
            },
            "settings": {
                "description": "",
                "title": ""
            },
            "show password": "Passwort anzeigen"
        },
        "recovery codes": {
            "banner description": "",
            "banner title": "",
            "checkbox title": "",
            "download error message": "",
            "first step description": "",
            "first step title": "",
            "input field title": "",
            "print error message": "",
            "second step description": "",
            "second step title": "",
            "settings": {
                "title": "",
                "description": ""
            }
        },
        "account": "",
        "description": "",
        "security": "",
        "security and account": ""
    },
    "Settings": {
        "version": ""
    },
    "Statistics": {
        "table statistics": "Tabellenstatistik",
        "statistics message": "Tabellenfilter wirken sich auf die unten angezeigten Statistiken aus",
        "activity": "Aktivität",
        "model": "Modell",
        "firmware": "Firmware",
        "configuration": "Konfiguration",
        "statistics": "Statistiken"
    },
    "Table": {
        "1_wire_authorization": "1-Wire-Autorisierung",
        "access group": "",
        "access groups": "",
        "access level": "Zugriffsebene",
        "accessories": "Zubehör",
        "action": "Aktion",
        "action date": "Aktionsdatum",
        "assigned package": "Zugewiesenes Paket",
        "attempt count": "Anzahl der Versuche",
        "attribute": "Attribut",
        "attributes": "Attribute",
        "auto sync": "",
        "batch id": "Batch-ID",
        "ble_dtb": "BLE DTB",
        "ble_fw": "BLE-Firmware",
        "bluetooth_authorization": "Bluetooth-Autorisierung",
        "bootloader": "Bootloader",
        "can_adapter": "CAN-Adapter",
        "can adapter name": "CAN-Adaptername",
        "can bootstring": "Bootstring",
        "can oem file package": "OEM-Dateipaket",
        "can oem file vehicle": "OEM-Datei-Vehikel",
        "can package": "CAN-Paket",
        "can program number": "CAN-Programmnummer",
        "can software date": "CAN-Software-Datum",
        "can type": "CAN-Typ",
        "carrier module id": "Modul-ID",
        "carrier revision": "Überarbeitung",
        "carrier serial id": "Serien-ID",
        "carrier settings filename": "Einstellungen Dateiname",
        "carrier unit status": "Status",
        "carrier unit type": "Gerätetyp",
        "changed at": "Geändert am",
        "change origin": "",
        "changes": "Änderungen",
        "checkbox disabled": {
            "role": "Statische Rollen können nicht bearbeitet oder gelöscht werden."
        },
        "child company": "<0>Tochtergesellschaft von</0><1>{{parentCompany}}</1>",
        "child companies": "Tochtergesellschaften",
        "code": "Code",
        "company": "Unternehmen",
        "company hierarchy": "Unternehmenshierarchie",
        "company name": "Firmenname",
        "compatibility": "Kompatibilität",
        "configuration": "Konfiguration",
        "configuration details": "Konfigurationsdetails",
        "configuration type": "",
        "created at": "Erstellt am",
        "created by": "Erstellt von",
        "date": "Datum",
        "description": "Beschreibung",
        "device details": "Gerätedetails",
        "device company": "Gerätehersteller",
        "device description": "Gerätebeschreibung",
        "device group": "Gerätegruppe",
        "device imei": "Geräte-IMEI",
        "device model": "Gerätemodell",
        "device seen at": "Gerät gesehen bei",
        "device serial": "Geräte-Seriennummer.",
        "devices": "Geräte",
        "devices count": "Anzahl der Geräte",
        "Done": "Fertig",
        "download at": "",
        "download file": "Datei herunterladen",
        "dtb": "DTB",
        "edit file": "Datei bearbeiten",
        "edit group banner": "Wenn ein Gerät zu einer Gruppe hinzugefügt wird, für die eine bestimmte Firmware und/oder Konfiguration definiert ist, werden alle zuvor ausstehenden Aufgaben desselben Typs storniert.",
        "email": "E-Mail",
        "empty table": {
            "no initial results": {
                "description": {
                    "batches": "Sobald Aufgabengruppen erstellt wurden, können Sie die Liste hier einsehen",
                    "changes": "Sobald Änderungen vorgenommen werden, können Sie die Liste hier einsehen",
                    "companies": "Sobald Unternehmen erstellt wurden, können Sie die Liste hier einsehen",
                    "configurationChanges": "",
                    "desktopLicenses": "Sobald Desktop-Lizenzen erstellt wurden, können Sie die Liste hier einsehen",
                    "devices": "Sobald Geräte auf FOTA WEB hochgeladen wurden, können Sie die Liste hier einsehen",
                    "files": "Sobald Dateien hochgeladen sind, können Sie die Liste hier einsehen",
                    "groups": "Sobald Gruppen erstellt wurden, können Sie die Liste hier einsehen",
                    "offlineLicenses": "Sobald Offline-Lizenzen erstellt wurden, können Sie die Liste hier einsehen",
                    "permissions": "Sobald dem Benutzer Berechtigungen zugewiesen wurden, können Sie die Liste hier einsehen",
                    "productCodes": "Sobald Produktcodes erstellt wurden, können Sie die Liste hier einsehen",
                    "roles": "Sobald die Rollen erstellt sind, können Sie die Liste hier einsehen",
                    "tasks": "Sobald Aufgaben erstellt wurden, können Sie die Liste hier einsehen",
                    "users": "Sobald Benutzer hinzugefügt werden, können Sie die Liste hier einsehen"
                },
                "title": {
                    "batches": "Die Tabelle mit den Aufgabengruppen ist leer",
                    "changes": "Die Tabelle „Änderungen“ ist leer",
                    "companies": "Die Unternehmenstabelle ist leer",
                    "configurationChanges": "",
                    "desktopLicenses": "Die Tabelle mit den Desktop-Lizenzen ist leer",
                    "devices": "Die Gerätetabelle ist leer",
                    "files": "Die Dateitabelle ist leer",
                    "groups": "Die Gruppentabelle ist leer",
                    "offlineLicenses": "Die Tabelle mit den Offline-Lizenzen ist leer",
                    "permissions": "Die Berechtigungstabelle ist leer",
                    "productCodes": "Die Produktcodetabelle ist leer",
                    "roles": "Die Rollentabelle ist leer",
                    "tasks": "Die Aufgabentabelle ist leer",
                    "users": "Die Benutzertabelle ist leer"
                }
            },
            "no permission": {
                "description": "Bitte wenden Sie sich an Ihren Administrator, um Zugriff zu beantragen.",
                "title": "Sie verfügen nicht über die erforderlichen Berechtigungen, um diesen Inhalt anzuzeigen"
            },
            "no results found": {
                "description": "Versuchen Sie es mit einem anderen Suchbegriff oder Filter, um Ergebnisse zu erhalten",
                "title": "Keine Ergebnisse gefunden"
            },
            "button": {
                "add": {
                    "companies": "Unternehmen erstellen",
                    "devices": "Gerät hinzufügen",
                    "files": "Datei hochladen",
                    "groups": "Gruppe erstellen",
                    "productCodes": "Produktcode hinzufügen",
                    "tasks": "Aufgabe erstellen",
                    "users": "Benutzer einladen"
                },
                "reset view": "Ansicht zurücksetzen"
            }
        },
        "exausted autoscan limit": "Automatischer Scan-Limit ausgeschöpft bis",
        "exausted vin parsing limit": "Das Limit für die VIN-Parsing-Funktion ist erschöpft bis",
        "expiration": "Ablauf",
        "expiration date": "Ablaufdatum",
        "expires at": "Läuft ab am",
        "expiry date": "Ablaufdatum",
        "field": "Bereich",
        "file": "Datei",
        "file id": "Datei-ID",
        "files": "Dateien",
        "file type": "Dateityp",
        "filter by": "Filtern nach",
        "firmware": "Firmware",
        "general": "Allgemein",
        "general data": "Allgemeine Daten",
        "gnss version": "GNSS-Version",
        "group": "Gruppe",
        "groups": "Gerätegruppen",
        "group vip status": "",
        "gsm number": "GSM-Nummer",
        "head title info": {
            "auto synced": {
                "changed at": "",
                "download at": "",
                "synced at": ""
            },
            "platform": {
                "fmx platform": "<1>FMx-Plattform</1> – FMx (FMB, FMU, FMC, FMM), FMT, FMP, TAT, MSP, TFT, TST, GH (GH5200) und TMT-Modelle.",
                "ft platform": "<1>FT-Plattform</1> – FTx- und ATx-Modelle.",
                "legacy platform": "<1>Ältere Plattform</1> – FM-Modelle (außer FM4001 und FM3010), FMA- und GH-Modelle (GH4000).",
                "title": "Plattformgenerierung des Telematikgeräts"
            },
            "visibility": "<2>Änderungen, die als <1>Intern</1> gekennzeichnet sind, sind für Kunden nicht sichtbar.</2><2>Da Geräteänderungen sowohl sichtbare als auch versteckte Daten umfassen können, <1>geben Sie keine Screenshots oder Details in der externen Kommunikation weiter</1>.</2>"
        },
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "imsi": "IMSI",
        "info": "Info",
        "interface": "Schnittstelle",
        "invited by": "Eingeladen von",
        "items": "Elemente",
        "last checked at": "Zuletzt geprüft am",
        "last sign in": "Letzte Anmeldung",
        "last status update": "Letzte Statusaktualisierung",
        "last used at": "Zuletzt verwendet bei",
        "license disabled": "Deaktiviert",
        "license enabled": "Aktiviert",
        "license key": "Lizenzschlüssel",
        "license name": "",
        "links": "Links",
        "manual_geofence_scenarios": "Manuelle Geofence-Szenarien",
        "message": "Nachricht",
        "model": "Modell",
        "model task type support": {
            "false": "Nicht unterstützt",
            "true": "Unterstützt"
        },
        "modem version": "Modem-Version",
        "name": "Name",
        "new value": "Neuer Mehrwert",
        "next task": "Nächste Aufgabe",
        "no changes": "Keine Änderungen.",
        "no company name": "Kein Firmenname",
        "no details": "Keine Details",
        "no file": "Keine Datei",
        "no imei available": "Keine IMEI verfügbar",
        "no model": "Kein Modell",
        "no parent company": "Das Unternehmen hat keine Muttergesellschaft.",
        "no tasks": "Das Gerät hat keine Aufgaben.",
        "number": "Anzahl",
        "obd": "OBD",
        "obd chip firmware version": "OBD-Chip-Firmware-Version",
        "of": "von",
        "offline licenses tab disabled": "Offline-Lizenzen sind für deaktivierte Desktop-Lizenzen nicht verfügbar.",
        "original value": "Ursprünglicher Wert",
        "other information": "Weitere Informationen",
        "page of": "Seite von",
        "parent company": "Muttergesellschaft",
        "permission count": "Anzahl der Berechtigungen",
        "platform": "Plattform",
        "Price": "Preis",
        "product code": "Produktcode",
        "program number": "Programmnummer",
        "property": "Eigenschaft",
        "queue": "Warteschlange",
        "receiving company": "Empfangendes Unternehmen",
        "revision": "Überarbeitung",
        "role": "Rolle",
        "role name": "Rollenname",
        "rows per page": "Zeilen pro Seite",
        "running": "Ausführung",
        "schedule": "Zeitplan",
        "seen at": "Gesehen bei",
        "select row": "Wählen Sie eine Zeile aus, um Details anzuzeigen",
        "send sms": "SMS senden",
        "serial": "Seriennummer.",
        "show details": {
            "desktopLicenses": "Details zur Desktop-Lizenz anzeigen",
            "devices": "Gerätedetails anzeigen",
            "batches": "Details zur Aufgabengruppe anzeigen",
            "tasks": "Aufgabendetails anzeigen",
            "companies": "Unternehmensdetails anzeigen"
        },
        "sim": "SIM",
        "size": "Größe",
        "software date": "Software-Datum",
        "source company": "Quellunternehmen",
        "spec_id": "Spec ID",
        "status": "Status",
        "status id": "Status-ID",
        "status name": "Statusname",
        "supported task types": "Unterstützte Aufgabentypen",
        "synced at": "",
        "table columns": "Tabellenspalten",
        "target company": "Zielunternehmen",
        "task id": "Aufgaben-ID",
        "task queue": "Aufgabenwarteschlange",
        "tasks": "Aufgaben",
        "task type": "Aufgabentyp",
        "tct web support": "TCT web support",
        "total": "Gesamt",
        "type": "Typ",
        "updated at": "Aktualisiert am",
        "updated by": "Aktualisiert von",
        "unknown": "Unbekannt",
        "user cannot be deleted": "Benutzer können nicht gelöscht werden.",
        "user cannot be edited": "Benutzer können nicht bearbeitet werden.",
        "user cannot delete himself": "Ein Benutzer kann sein eigenes Profil nicht löschen.",
        "user date statuses": {
            "expired": "Abgelaufen",
            "expires": "Läuft ab",
            "never expires": "Läuft nie ab",
            "sent": "Gesendet"
        },
        "user email": "Benutzer-E-Mail",
        "user invitation cannot be cancelled": "Benutzereinladungen können nicht storniert werden.",
        "user invitation cannot be resent": "Benutzereinladungen können nicht erneut versendet werden.",
        "user statuses": {
            "Active": "Aktiv",
            "Inactive": "Inaktiv",
            "InvitationExpired": "Abgelaufene Einladung",
            "InvitationPending": "Einladung ausstehend"
        },
        "users": "Benutzer",
        "value from": "Wert aus",
        "value to": "Mehrwert für",
        "view all roles": "Alle anzeigen ({{count}})",
        "vin": "VIN",
        "vip status": "VIP-Status",
        "visibility": "Sichtbarkeit"
    },
    "Table details": {
        "bluetooth password": {
            "aria label unknown tooltip": "",
            "disabled copy tooltip": "",
            "unknown": "",
            "unknown tooltip": ""
        },
        "device group tasks": "",
        "group tasks": "",
        "number of devices": "",
        "permissions info": "Informationen zu Berechtigungen",
        "smart group files": "",
        "tooltip info": {
            "devices": {
                "accessories": {
                    "interface": "Name der Zubehörschnittstelle.",
                    "type": "Angeschlossener Zubehörtyp."
                },
                "can": {
                    "assigned package": "Das dem Gerät zugewiesene OEM-Paket.",
                    "can oem file package": "Das OEM-Paket, das bei der letzten Verbindung gemeldet wurde.",
                    "can oem file vehicle": "die während der letzten Verbindung gemeldete OEM-Fahrzeugkonfiguration.",
                    "dtb": "",
                    "firmware": "die Version der CAN-Firmware."
                },
                "can_adapter": {
                    "can adapter name": "",
                    "can bootstring": "Die zuletzt empfangene Startzeichenfolge des CAN-Adapters mit aktuellen Daten und der Programmnummer des Adapters.",
                    "program number": "Die Programmnummer des CAN-Adapters.",
                    "revision": "",
                    "software date": "Das Software-Datum des CAN-Adapters.",
                    "type": "Typ des CAN-Adapters."
                },
                "configuration details": {
                    "1_wire_authorization": "Der Name der zuletzt gesendeten 1-Wire-Autorisierungsliste.",
                    "bluetooth_authorization": "Der Name der zuletzt gesendeten Bluetooth-Autorisierungsliste.",
                    "main configuration": "Name der zuletzt gesendeten Hauptkonfigurationsdatei.",
                    "manual_geofence_scenarios": "Der Name der zuletzt gesendeten manuellen Geofence-Listendatei."
                },
                "general": {
                    "ble_dtb": "",
                    "ble_fw": "Die Version der BLE-Firmware, die bei der letzten Verbindung gemeldet wurde.",
                    "bluetooth password": "",
                    "bootloader": "Die Version des Geräte-Bootloaders, die bei der letzten Verbindung gemeldet wurde.",
                    "company": "Das Unternehmen, dem dieses Gerät gehört.",
                    "configuration": "Name der zuletzt gesendeten Konfigurationsdatei.",
                    "description": "Gerätebeschreibung (benutzerdefiniert).",
                    "dtb": "Die Version des Device Tree Blobs, die bei der letzten Verbindung gemeldet wurde.",
                    "firmware": "Die Version der Geräte-Firmware, die bei der letzten Verbindung gemeldet wurde.",
                    "gnss version": "Die während der letzten Verbindung gemeldete GNSS-Version.",
                    "group": "Die Gerätegruppe, der dieses Gerät zugeordnet ist.",
                    "product code": "Der Produktcode des Geräts.",
                    "serial": "die Seriennummer des Geräts."
                },
                "obd": {
                    "obd chip firmware version": "Die Version der OBD-Chip-Firmware, die bei der letzten Verbindung gemeldet wurde.",
                    "vin": "Ein einzigartiger 17-stelliger Code, der ein bestimmtes Kraftfahrzeug identifiziert."
                },
                "sim": {
                    "gsm number": "Die mit einem Gerät verbundene öffentliche Telefonnummer.",
                    "iccid": "Eine eindeutige Seriennummer, die eine SIM-Karte identifiziert.",
                    "imsi": "Eine eindeutige Kennung für einen Mobilfunkteilnehmer."
                }
            },
            "groups": {
                "fmx platform files": {
                    "configuration": "",
                    "firmware": ""
                },
                "ft platform files": {
                    "1_wire_authorization_list": "",
                    "bluetooth_authorization_list": "",
                    "firmware": "",
                    "main configuration": ""
                }
            },
            "users": {
                "general": {
                    "created at": "Datum und Uhrzeit der Benutzererstellung.",
                    "id": "die eindeutige ID des Benutzers.",
                    "invited by": "E-Mail-Adresse des Benutzers, der die Einladung erstellt hat.",
                    "role": "Dem Benutzer zugewiesene Rolle(n).",
                    "updated at": "Datum und Uhrzeit der letzten Benutzeraktualisierung."
                }
            }
        },
        "user details": "Benutzerdaten"
    },
    "Task groups": {
        "all": "Alle",
        "bulk type": {
            "CompanyBulkDelete": "Unternehmen löschen",
            "DeviceBulkCreate": "Gerät hinzufügen",
            "DeviceBulkDelete": "Gerät löschen",
            "DeviceBulkUpdate": "Gerät aktualisieren",
            "FileBulkDelete": "Datei löschen",
            "GroupBulkDelete": "Gruppe löschen",
            "TaskBulkCreate": "Aufgabe erstellen",
            "TaskBulkUpdate": "Aufgabe abbrechen",
            "UserBulkDelete": "Benutzer löschen"
        },
        "pending approval": "Zur Genehmigung vorgelegt",
        "already approved": "Bereits genehmigt",
        "no approval required": "Keine Genehmigung erforderlich",
        "total objects": "Gesamtzahl der Objekte",
        "total tasks": "Gesamtzahl der Aufgaben"
    },
    "Task status": {
        "0": "Ausstehend",
        "1": "Ausführung",
        "2": "Abgeschlossen",
        "3": "Mit Fehlern abgeschlossen",
        "4": "Abgebrochen",
        "5": "Fehlgeschlagen",
        "6": "Abgelaufen",
        "7": "Warten auf Genehmigung",
        "8": "Überprüfen",
        "task count": {
            "0": "Ausstehende Aufgaben",
            "1": "Ausführende Aufgaben",
            "3": "Mit Fehlern abgeschlossene Aufgaben",
            "5": "Fehlgeschlagene Aufgaben"
        },
        "verified tooltip title": "Die Aufgabe wurde erfolgreich abgeschlossen und vom Gerät überprüft."
    },
    "Tasks": {
        "0": "Die Aufgabe befindet sich in der Warteschlange und ist nun ausstehend.",
        "1": "Die Aufgabe wird derzeit ausgeführt.",
        "2": "Die Aufgabe wurde erfolgreich abgeschlossen.",
        "3": "Die Aufgabe wurde abgeschlossen, es sind jedoch einige Fehler aufgetreten.",
        "4": "Die Aufgabe wurde abgebrochen.",
        "5": "Die Aufgabe ist fehlgeschlagen.",
        "6": "Die Aufgabe wurde nicht innerhalb eines bestimmten Zeitrahmens abgeschlossen."
    },
    "Tct": {
        "edit configuration": "Konfiguration bearbeiten",
        "no editable configurations": "Es werden keine editierbaren Konfigurationen hochgeladen",
        "open tct": "Öffnen Sie die TCT web-Version",
        "open tct description": "Erstellen Sie eine neue Konfiguration in der TCT web-Version oder bearbeiten Sie eine vorhandene Konfigurationsdatei aus FOTA WEB.",
        "select configuration file": "Wählen Sie eine Konfigurationsdatei aus, die Sie in TCT web bearbeiten möchten.",
        "tct web": "TCT web",
        "tct web disabled description": "Die TCT web-Version ist nur für Unternehmen mit Premium-Status verfügbar."
    },
    "Tutorial": {
        "buttons": {
            "exit": "",
            "finish": "",
            "get started": "",
            "next": "",
            "next feature": ""
        },
        "content": {
            "company selector": {
                "0": "",
                "1": "",
                "1-info": ""
            },
            "finish tutorial": "",
            "first time user": "",
            "task groups": {
                "desktop": {
                    "0": "",
                    "1": ""
                },
                "mobile": {
                    "0": "",
                    "1": ""
                }
            }
        },
        "titles": {
            "finish tutorial": "",
            "first time user": "",
            "tutorial mode": ""
        }
    }
}
